import * as styles from './theme';
import { DashboardWebComponent } from './dashboard';
import { MspEdrTrialReportWebComponent } from './mspEdrTrialReport';
import { DashboardAppWebComponent } from './dashboardApp';
import { OverviewWebComponent } from './overview';
import { TopThreatsWebComponent } from './topThreats';
import { ThreatsBreakdownWebComponent } from './threatsBreakdown';
import { RemediationsWebComponent } from './remediations';
import { IncidentsWebComponent } from './incidentsStatus';
import { InventoryWebComponent } from './inventory';
import { GzSelectWebComponent, SelectOverlayElement } from './ui/gzSelect';
import { GzGaugeWebComponent } from './ui/gzGauge';
import { AccessDataProtectionComponent } from './accessDataProtection';
import { EndpointModulesWebComponent } from './endpointModulesStatus';
import { EndpointModulesStatusDetailsWebComponent } from './executiveSummary/endpointModulesStatusDetails';
import { CompanyRiskScoreWebComponent } from './companyRiskScore';
import { GzProgressWebComponent } from './ui/gzProgress';
import { GzProgressThinWebComponent } from './ui/gzProgressThin';
import { GzCounterWebComponent } from './ui/gzCounter';
import { WebsitesBlockedComponent } from './websitesBlocked';
import { NetworkAttackWebComponent } from './networkAttackTechniques';
import { GzLoaderWebComponent } from './ui/gzLoader';
import { GzTooltipBoxWebComponent, GzTooltipWebComponent } from './ui/gzTooltip';
import { GzDashboardLoadingScreenWebComponent } from './ui/gzDashboardLoadingScreen';
import { GzDropdownWebComponent } from './ui/gzDropdown';
import { GzDialogWebComponent } from './ui/gzDialog';
import { AlertsAppWebComponent } from './alertsApp';
import { AlertsWebComponent } from './alerts';
import { GzDropdownMenuWebComponent } from './ui/gzDropdownMenu';
import { GridViewWebComponent } from './grid/gridView';
import { GridFiltersWebComponent } from './grid/gridFilters';
import { LiveSearchMetadataGridComponent } from './xdr/liveSearch/metadataGrid';
import { GridFooterWebComponent } from './grid/gridFooter';
import { GzRadioGroupWebComponent, GzRadioWebComponent } from './ui/gzRadio';
import { GzButtonWebComponent, GzSplitButtonWebComponent } from './ui/gzButton';
import {
  GzClearableInputWebComponent,
  GzInputNumberWebComponent,
  GzInputSearchWebComponent,
  GzTextareaWebComponent,
} from './ui/gzInput';
import { GzHealthDashboardUpdateStatusWebComponent } from './healthDashboard/widgetTemplates/insightsTemplates';
import { GzHealthDashboardEndpointIssuesWebComponent } from './healthDashboard/widgetTemplates/insightsTemplates';
import { GzHealthDashboardPoliciesWebComponent } from './healthDashboard/widgetTemplates/insightsTemplates';
import { GzHealthDashboardEndpointEncryptionWebComponent } from './healthDashboard/widgetTemplates/endpointEncryption';
import { GzEasmScheduleControllerWebComponent } from './easm/widgets/scheduleController';
import { GzCheckboxWebComponent } from './ui/gzCheckbox';
import { GzEnumFilterWebComponent } from './ui/gzEnumFilter';
import { GzSideMenuWebComponent } from './ui/gzSideMenu';
import { GzEnumListWebComponent } from './ui/gzEnumList';
import { GridSettingsWebComponent } from './grid/gridSettings';
import { GridSmartViewsWebComponent } from './grid/gridSmartViews';
import { CompanySelectorWebComponent } from './companySelector';
import { GzRemovableWebComponent } from './ui/gzRemovable';
import { GzDatetimeFilterWebComponent } from './ui/gzDatetimeFilter';
import { GzTitleWebComponent } from './ui/gzTitle';
import { GzToggleWebComponent } from './ui/gzToggle';
import { GzProgressSpinnerWebComponent } from './ui/gzProgressSpinner';
import { GzDateRangePickerWebComponent } from './ui/gzDateRangePicker';
import { GzImageRepoWebComponent } from './ui/gzImageRepo';
import { catchError } from 'rxjs/operators';
import { TIME_RANGE } from '@nirvana/shared/constants';
import { MyCompanyPanelWebComponent } from './company/myCompany/myCompanyPanel';
import { EditCompanyPanelWebComponent } from './company/editCompany/editCompanyPanel';
import { GzTabGroupWebComponent } from './ui/gzTabs/gzTabGroup';
import { GzTabWebComponent } from './ui/gzTabs/gzTab';
import { Observable } from 'rxjs';
import { CompanyDetailsTabWebComponent } from './company/common/companyDetailsTab';
import { GzFormFieldToggleableWebComponent, GzFormFieldWebComponent } from './ui/gzForm/formField';
import { GzInputErrorWebComponent } from './ui/gzForm/inputError';
import { GlobalExclusionsAppWebComponent } from './configurationProfilesApp/exclusionsApp';
import { ConfigurationProfilesWebComponent } from './configurationProfilesApp/configurationProfiles';
import { GlobalExclusionsWebComponent } from './configurationProfilesApp/exclusionsPanel';
import { ExclusionListsWebComponent } from './configurationProfilesApp/exclusionsLists';
import { NewExclusionListWebComponent } from './configurationProfilesApp/exclusionListItemsEditPanel';
import { ExclusionListFormWebComponent } from './configurationProfilesApp/exclusionListForm';
import { ExclusionItemFormWebComponent } from './configurationProfilesApp/exclusionItemForm';
import { ExclusionItemGridWebComponent } from './configurationProfilesApp/exclusionItemGrid';
import { ExportExclusionsPanelWebComponent } from './configurationProfilesApp/exclusionsExportPanel';
import { GzWizardStepWebComponent, GzWizardWebComponent } from './ui/gzWizard';
import { GzAccordionWebComponent } from './ui/gzAccordion';
import { GzInputFileWebComponent } from './ui/gzInputFile';
import { CompanyAuthenticationTabWebComponent } from './company/common/authenticationTab';
import { GzCopyToClipboardWebComponent } from './ui/gzCopyToClipboard';
import { CompanyLicensingTabWebComponent } from './company/common/licensingTab';
import { CompanyMspInProductTrialsTabWebComponent } from './company/common/mspInProductTrialsTab';
import { ChangePartnerMenuWebComponent } from './company/myCompany/changePartnerMenu';
import { AddProductMenuWebComponent } from './company/common/addProductMenu';
import { EditLicensingOptionsMenuWebComponent } from './company/common/editLicensingOptionsMenu';
import { PlansAndPurchaseTabWebComponent } from './company/myCompany/purchase/plansAndPurchaseTab';
import { jsTimestampToUnixTimestamp, timeRangeToReportingInterval } from '@nirvana/shared/time';
import { GzIconButtonWebComponent } from './ui/gzIconButton';
import { GzLabeledContentWebComponent } from './ui/gzLabeledContent';
import { GzToastElement, GzToastNotificationWebComponent } from './ui/gzToastNotification';
import { GzListItemWebComponent } from './ui/gzListItem';
import { GridCellEditWebComponent } from './grid/uiElements/gridCellEdit';
import { PoliciesSelectorWebComponent } from './policiesSelector';
import { ExclusionListSelectorWebComponent } from './configurationProfilesApp/exclusionListSelector';
import { GzTableWebComponent } from './ui/gzTable';
import { GzBasicTableWebComponent } from './ui/gzBasicTable';
import { RemoteShellWebComponent } from './remoteShell/remoteShellWindow';
import { TerminalWebComponent } from './remoteShell/terminal';
import { EndpointDetailsWebComponent } from './endpointDetails';
import { GzLinkWebComponent } from './ui/gzLinkComponent';
import { DownloadSecurityContainerWebComponent } from './packages/downloadSecurityContainerWindow';
import { DownloadK8sAgentWebComponent } from './packages/downloadK8sAgentWindow';
import { PackageGeneralFormWebComponent } from './packages/common/packageGeneralForm';
import { PackageModulesFormWebComponent } from './packages/common/packageModulesForm';
import { PackageScanModesFormWebComponent } from './packages/common/packageScanModesForm';
import { PackageSettingsFormWebComponent } from './packages/common/packageSettingsForm';
import { PackageMiscellaneousFormWebComponent } from './packages/common/packageMiscellaneousForm';
import { PackagePanelWebComponent } from './packages/packagePanel';
import { PackagesAppWebComponent } from './packages/packagesApp';
import { DownloadKitButtonSelectorWebComponent } from './packages/downloadKitButtonSelector';
import { PackageDeployerFormWebComponent } from './packages/common/packageDeployerForm';
import { DeployerGridWebComponent } from './packages/common/deployerGrid';
import { ActivityGridWebComponent } from './endpointInvestigation/activityGrid';
import { AccountsGridWebComponent } from './accounts/accountsGrid';
import { AddAccountWebComponent } from './accounts/addAccount';
import { EditAccountWebComponent } from './accounts/editAccount';
import { TargetsWebComponent } from './targets';
import { AccountRoleAndPrivilegesWebComponent } from './accounts/common/accountRoleAndPrivileges';
import { AccountLoginSecurityWebComponent } from './accounts/common/accountLoginSecurity';
import { AccountDetailsWebComponent } from './accounts/common/accountDetails';
import { GzTextWebComponent } from './ui/gzText';
import { GzInfoBoxWebComponent } from './ui/gzInfoBox';
import { GzMultiSelectGroupWebComponent, GzMultiSelectItemWebComponent } from './ui/gzMultiSelect';
import { GzTimePickerWebComponent } from './ui/gzTimePicker';
import { GzDatePickerWebComponent } from './ui/gzDatePicker';
import { ImportantMessagesWebComponent } from './importantMessages';
import { MaintenanceWindowsAppWebComponent } from './configurationProfilesApp/maintenanceWindowsApp';
import { MaintenanceWindowFormWebComponent } from './configurationProfilesApp/maintenanceWindowForm';
import { MaintenanceWindowSelectorWebComponent } from './maintenanceWindows/maintenanceWindowSelector';
import { MaintenanceWindowPreviewPatchManagementWebComponent } from './maintenanceWindows/maintenanceWindowPreviewPatchManagement';
import { MaintenanceWindowGridWebComponent } from './configurationProfilesApp/maintenanceWindowGrid';
import { MaintenanceWindowFormPatchSpecificsWebComponent } from './configurationProfilesApp/maintenanceWindowFormPatchSpecifics';
import { MaintenanceWindowSchedulerWebComponent } from './maintenanceWindows/maintenanceWindowScheduler';
import { MaintenanceWindowPatchManagementVendorProductSelectorWebComponent } from './configurationProfilesApp/maintenanceWindowPatchManagementVendorProductSelector';
import { MaintenanceWindowSimpleSchedulerWebComponent } from './maintenanceWindows/maintenanceWindowSimpleScheduler';
import { RelayPatchCachingServersWebComponent } from './maintenanceWindows/relayPatchCachingServers';
import { MaintenanceWindowRebootOptionsWebComponent } from './maintenanceWindows/maintenanceWindowRebootOptions';
import { CompanyDetailsFormWebComponent } from './company/common/companyDetailsForm';
import { CreateCompanyPanelWebComponent } from './company/createCompany/createCompanyPanel';
import { CompanyAuthenticationFormWebComponent } from './company/common/authenticationSettingsForm';
import { LicenseMainFormWebComponent } from './license/licenseMainForm';
import { LicenseTrialSubFormWebComponent } from './license/licenseTrialSubForm';
import { LicenseFratSubFormWebComponent } from './license/licenseFratSubForm';
import { LicensePrePaidSubFormWebComponent } from './license/licensePrePaidSubForm';
import { LicenseBasicMonthlySubscriptionSubFormWebComponent } from './license/licenseBasicMonthlySubscriptionSubForm';
import { LicenseMonthlyLicenseTrialSubFormWebComponent } from './license/licenseMonthlyLicenseTrialSubForm';
import { LicenseMonthlySubscriptionTrialSubFormWebComponent } from './license/licenseMonthlySubscriptionTrialSubForm';
import { LicenseMonthlySubscriptionSubFormWebComponent } from './license/licenseMonthlySubscriptionSubForm';
import { LicenseMonthlyServicesFormWebComponent } from './license/common/servicesForm';
import { LicenseMonthlyAddonsFormWebComponent } from './license/common/addonsForm';
import { LicenseMonthlyOwnBundleFormWebComponent } from './license/common/ownBundleForm';
import { LicenseMonthlyResellBundleFormWebComponent } from './license/common/resellBundleForm';
import { LicenseMonthlyAvailableBundlesForAffectedDescendantsFormWebComponent } from './license/common/availableBundlesForAffectedDescendantsForm';
import { CustomFieldsFormWebComponent } from './company/common/customFieldsForm';
import { GzFormListWebComponent } from './ui/gzForm/formList';
import { InlineRowActionsWebComponent } from './grid/uiElements/inlineRowActions';
import { IntegrationCreatePanelWebComponent } from './xdr/addIntegrationPanel';
import { SelectIntegrationTypeWebComponent } from './xdr/selectIntegrationType';
import { IntegrationSelectCompanyWebComponent } from './xdr/integrationSelectCompany';
import { O365MailWebComponent } from './xdr/sensors/o365Mail';
import { O365AuditWebComponent } from './xdr/sensors/o365Audit';
import { GzCardWebComponent } from './ui/gzCard';
import { GzQueryInputWebComponent } from './ui/gzQueryInput';
import { XdrSearchQueryPanelWebComponent } from './xdrSearchApp/xdrSearchQueryPanel';
import { XdrSearchResultsPanelWebComponent } from './xdrSearchApp/xdrSearchResultsPanel';
import { XdrSearchWebComponent } from './xdrSearchApp/xdrSearch';
import { XdrSearchTabPanelComponent } from './xdrSearchApp/xdrSearchTabPanel';
import { XdrSearchLiveWebComponent } from './xdrSearchApp/xdrSearchLive';
import { XdrLiveSearchQueryPanelWebComponent } from './xdrSearchApp/xdrLiveSearchQueryPanel';
import { GzChipItemWebComponent, GzChipsGroupWebComponent } from './ui/gzChips';
import { MaintenanceWindowsSideNavWebComponent } from './maintenanceWindows/maintenanceWindowsSideNav';
import { EditIntegrationWebComponent } from './xdr/editIntegration';
import { IntegrationRequirementsWebComponent } from './xdr/integrationRequirements';
import { SendFeedbackWebComponent } from './xdr/sendFeedbackEmail';
import SensorsIntegrationsGridComponent from './xdr/integrationsGrid';
import SensorsIntegrationDetailsPanelComponent from './xdr/integrationDetailsPanel';
import { DynamicColumnLayoutWebComponent } from './ui/layouts/dynamicColumnLayout';
import { IntegrationSavedSuccessWebComponent } from './xdr/integrationSavedSuccess';
import { XdrOverviewWebComponent } from './xdr/xdrOverview';
import { SummaryPanelWebComponent } from './xdr/summaryPanel';
import { TimelineItemWebComponent } from './xdr/timelineItem';
import { TimelineGroupWebComponent } from './xdr/timelineGroup';
import { TacticsAndTechniquesWebComponent } from './xdr/tacticsAndTechniques';
import { OrganizationalImpactWebComponent } from './xdr/organizationalImpact';
import { GzPushBodyLayoutWebComponent } from './ui/gzPushBodyLayout';
import { GzFlexibleTableWebComponent } from './ui/gzFlexibleTable';
import { GzClipContentWebComponent } from './ui/gzClipContent';
import { ResponseGridWebComponent } from './xdr/responseGrid';
import { ResponsePanelWebComponent } from './xdr/responsePanel';
import { ResponsePanelItemWebComponent } from './xdr/responsePanelItem';
import { IntegrationTypeCardWebComponent } from './xdr/integrationTypeCard';
import { GzCompanyListWebComponent } from './ui/gzCompanyList';
import { GzCompanyFilterWebComponent } from './ui/gzCompanyFilter';
import { GzEndpointListWebComponent } from './ui/gzEndpointList';
import { GzEndpointFilterWebComponent } from './ui/gzEndpointFilter';
import { GzCollapsableContainerWebComponent } from './ui/gzCollapsableContainer';
import { GzPaginationWebComponent } from './grid/uiElements/gzPagination';
import { GridViewTitleWebComponent } from './grid/uiElements/gridViewTitle';
import { ExchangeProtectionWebComponent } from './quarantine/exchangeProtection';
import { ComputersAndVirtualMachinesWebComponent } from './quarantine/computersAndVirtualMachines';
import { QuarantineComputersAndVirtualMachinesRestoreForm } from './quarantine/uiElements/quarantineComputersAndVirtualMachinesRestoreForm';
import { QuarantineSaveFormWebComponent } from './quarantine/uiElements/quarantineSaveForm';
import { CompaniesGridWebComponent } from './companies/companiesGrid';
import { CompaniesAppWebComponent } from './companies/companiesApp';
import { AlertsDetailsPanelComponent } from './alertsDetailsPanel';
import { GridSelectionExtraOptionsWebComponent } from './grid/uiElements/gridSelectionExtraOptions';
import { LightGridWebComponent } from './grid/lightGrid';
import { GzJsonViewerWebComponent } from './ui/gzJsonViewer';
import { MaintenanceWindowsDeleteDialogWebComponent } from './maintenanceWindows/maintenanceWindowsDeleteDialog';
import { GzTreeWebComponent } from './ui/gzTree';
import { GzNodeDirectorWebComponent } from './ui/gzTree/uiElements/gzNodeDirector';
import { GzNodeRenameInputWebComponent } from './ui/gzTree/uiElements/gzNodeRenameInput';
import { GzLoadMoreNodesButtonWebComponent } from './ui/gzTree/uiElements/gzLoadMoreNodesButton';
import { RawEventsConfigurationGridWebComponent } from './rawEventsConfigurationGrid';
import { IntegrityMonitorEventsWebComponent } from './integrityMonitor/integrityMonitorEvents/integrityMonitorEventsGrid';
import { IntegrityMonitorDetailsPanelWebComponent } from './integrityMonitor/integrityMonitorEvents/integrityMonitorEventsDetailsPanel';
import { IntegrityMonitorRealTimePanelWebComponent } from './policies/integrityMonitor/realTime/integrityMonitorRealTimePanel';
import { IntegrityMonitorPauseWebComponent } from './tasks/IntegrityMonitoringPause';
import { IntegrityMonitorPolicyRuleSetsSectionWebComponent } from './policies/integrityMonitor/realTime/integrityMonitorPolicyRuleSetsSection';
import { IntegrityMonitorRulesAppWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorRulesApp';
import { IntegrityMonitorRulesSmartViewsWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorRulesSmartViews';
import { IntegrityMonitorRulesGridWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorRulesGrid';
import { IntegrityMonitorRuleSetFormWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorRuleSetForm';
import { IntegrityMonitorAssignRulesFormWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorAssignRulesForm';
import { IntegrityMonitorDefaultRuleConfigurationWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorDefaultRuleConfiguration';
import { IntegrityMonitorAddCustomRulePanelWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imAddCustomRulePanel';
import { IntegrityMonitorCustomRuleMainFormWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleMainForm';
import { IntegrityMonitorCustomRuleActionsFormWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleActionsForm';
import { IntegrityMonitorCustomRuleActionItemWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleActionItem';
import { IntegrityMonitorDirectoryRuleFormWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleDirectoryForm';
import { IntegrityMonitorFileRuleFormWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleFileForm';
import { IntegrityMonitorRegistryKeyRuleFormWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleRegistryKeyForm';
import { IntegrityMonitorRegistryValueRuleFormWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleRegistryValueForm';
import { IntegrityMonitorInputWithChipsWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleInputWithChips/IntegrityMonitorCustomRuleInputWithChipsWebComponent';
import { IntegrityMonitorFilePathFormFieldWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleFilePathFormField/IntegrityMonitorFilePathFormFieldWebComponent';
import { IntegrityMonitorDirectoryPathFormFieldWebComponent } from './integrityMonitor/integrityMonitorRules/integrityMonitorCustomRules/imCustomRuleDirectoryPathFormField/IntegrityMonitorDirectoryPathFormFieldWebComponent';
import { GridCellDefaultRendererWebComponent } from './grid/uiElements/gridCellDefaultRenderer';
import { NotesPanelWebComponent } from './notes/notesPanel';
import { NotesListWebComponent } from './notes/notesList';
import { NoteCardWebComponent } from './notes/noteCard';
import { NoteEditorWebComponent } from './notes/noteEditor';
import { IncidentHistoryWebComponent } from './history/incidentHistory';
import { CardHistoryWebComponent } from './history/cardHistory';
import { CompanyBetaProgramsTabWebComponent } from './company/common/betaProgramsTab';
import { BetaProgramSection } from './company/common/betaProgramsTab/innerComponents/betaProgramSection';
import { GzCountDownWebComponent } from './ui/gzCountDown';
import { LiveSearchResultsGridComponent } from './xdr/liveSearch/resultsGrid';
import { GzSliderWebComponent } from './ui/gzSlider';
import { GzRangeSliderInputWebComponent } from './ui/gzRangeSliderInput';
import { GenericSmartViewsListWebComponent } from './grid/genericSmartViewsList';
import { IncidentsGridWebComponent } from './edr/incidentsGrid';
import { GenericGridSmartViewsWebComponent } from './grid/genericGridSmartViews';
import { GzDynamicFormInputWebComponent, GzDynamicFormWrapperWebComponent } from './ui/gzDynamicFormWrapper';
import { GzSingleSelectWebComponent } from './ui/gzSingleSelectDropdown';
import { GzSingleSelectListWebComponent } from './ui/gzSingleSelectList';
import { GzSingleSelectComplexWebComponent } from './ui/gzSingleSelectComplex';
import { TagsManagerGridWebComponent } from './tagsManager/tagsManagerGrid';
import { TagsManagerWebComponent } from './tagsManager/tagsManager';
import { TagPanelWebComponent } from './tagsManager/tagPanel';
import { TagDetailsFormWebComponent } from './tagsManager/common/tagDetailsForm';
import { TagsNetworkFilterWebComponent } from './tagsManager/tagsNetworkFilter';
import { GzTagsEnumListWebComponent } from './tagsManager/ui/gzTagsEnumList';
import { GzTagsEnumFilterWebComponent } from './tagsManager/ui/gzTagsEnumFilter';
import { InlineTagFormWebComponent } from './tagsManager/ui/inlineTagForm';
import { GzIconLabelWebComponent } from './ui/gzIconLabel';
import { IncidentsSideMenuWebComponent } from './edr/incidentsSideMenu';
import { LiveSearchMetadataWebComponent } from './xdr/liveSearch/metadata';
import { XdrIncidentDetailsWebComponent } from './edr/xdrIncidentDetails';
import { EdrIncidentDetailsWebComponent } from './edr/edrIncidentDetails';
import { IncidentDetailsAnalysisSectionWebComponent } from './edr/incidentDetailsSections/incidentDetailsAnalysisSection';
import { IncidentGeneralSectionWebComponent } from './edr/incidentDetailsSections/incidentGeneralSection';
import { IncidentAttackInfoWebComponent } from './edr/incidentDetailsSections/incidentAttackInfo';
import { ShowMoreItemsWebComponent } from './edr/incidentDetailsSections/showMoreItems';
import { IncidentDetailsDetectionsSectionWebComponent } from './edr/incidentDetailsSections/incidentDetailsDetectionsSection';
import { IncidentDetailsTechniquesSectionWebComponent } from './edr/incidentDetailsSections/incidentDetailsTechniquesSection';
import { PackagesGridWebComponent } from './packages/packagesGrid';
import { ShowMoreItemsInBulkWebComponent } from './edr/incidentDetailsSections/showMoreItemsInBulk';
import { ResponseGridWebComponent as EdrResponseGridWebComponent } from './edr/responseGrid';
import { GzDashboardGridStackManagerWebComponent } from './genericDashboard/gzDashboardGridStackManager';
import { SchemaHelperWebComponent } from './xdr/liveSearch/schemaHelper';
import { GridSummaryWebComponent } from './grid/uiElements/gridSummary';
import { GzDashboardSmartViewsListWebComponent } from './genericDashboard';
import { GzDashboardSaveAsDialogContentWebComponent } from './genericDashboard/gzDashboardPopUps/gzDashboardSaveAsDialogContent';
import { GzDashboardFeedBackDialogContentWebComponent } from './genericDashboard/gzDashboardPopUps/gzDashboardFeedBackDialogContent';
import { GzDashboardDeleteViewDialogContentWebComponent } from './genericDashboard/gzDashboardPopUps/gzDashboardDeleteViewDialogContent';
import { GzDashboardDiscardChangesDialogContentWebComponent } from './genericDashboard/gzDashboardPopUps/gzDashboardDiscardChangesDialogContent';
import { GzDashboardUnsavedChangesDialogContentWebComponent } from './genericDashboard/gzDashboardPopUps/gzDashboardUnsavedChangesDialogContent';
import { GzDashboardSmartViewsToolbarWebComponent } from './genericDashboard/gzDashboardSmartViewsToolbar';
import { PackageSecurityServerAssignmentGridWebComponent } from './packages/common/packageSecurityServerAssignmentGrid';
import { GzEnumerationIconWebComponent } from './ui/gzEnumerationIcon';
import { GzBannerWebComponent } from './ui/gzBanner';
import { MobileSecurityCompanyGridWebComponent } from './mobileSecurity/mobileSecurityCompanyGrid';
import { MobileSecurityCustomerViewWebComponent } from './mobileSecurity/mobileSecurityCustomerView';
import { CloudWorkloadSecurityCustomerViewWebComponent } from './cloudWorkloadSecurity/cloudWorkloadSecurityCustomerView';
import { MobileSecurityActivationEmailsDialogBodyWebComponent } from './mobileSecurity/mobileSecurityActivationEmailsDialog/mobileSecurityActivationEmailsDialogBody';
import { GzInfoOverlayWebComponent, GzOverlay } from './ui/gzInfoOverlay';
import { GzChipsGeneratorInputWebComponent } from './ui/gzChipsGeneratorInput';
import { GzTrialProductItemWebComponent } from './productTrials/common/gzTrialProductItem';
import { GzTrialHomePageWebComponent } from './productTrials/b2b/gzTrialHomePage';
import { B2bLandingPageWebComponent } from './productTrials/b2b/b2bLandingPage';
import { MspLandingPageWebComponent } from './productTrials/msp/mspLandingPage';
import { TasksWebComponent } from './tasks/networkTasks';
import { SubTasksWebComponent } from './tasks/networkSubTasks';
import { InProductTrialsAppWebComponent } from './productTrials/b2b/inProductTrialsApp';
import { InProductTrialsOverlayContentWebComponent } from './productTrials/b2b/inProductTrialsOverlayWindow/inProductTrialsOverlayContent';
import { GzInProductTrialsHeaderWebComponent } from './productTrials/b2b/inProductTrialsHeader';
import { MspInProductTrialsOverlayContentWebComponent } from './productTrials/msp/mspInProductTrialsOverlays/mspInProductTrialsOverlayContent';
import { UploadWindowWebComponent } from './remoteShell/uploadWindow';
import { DownloadWindowWebComponent } from './remoteShell/downloadWindow';
import { GzDashboardMacroComponentWebComponent } from './genericDashboard/gzDashboardMacroComponent';
import { InProductTrialsOverlayWindowsAppWebComponent } from './productTrials/b2b/inProductTrialsOverlayWindow/inProductTrialsOverlayWindowsApp';
import { MspInProductTrialsOverlayWindowsAppWebComponent } from './productTrials/msp/mspInProductTrialsOverlays/mspInProductTrialsOverlaysApp';
import { PackageUseProxyFormWebComponent } from './packages/common/packageUseProxyForm';
import { GzBulkActionsBarWebComponent } from './ui/gzBulkActionsBar';
import { ReconfigureAgentPanelWebComponent } from './network/reconfigureAgent/reconfigureAgentPanel';
import { ReconfigureAgentTypeFormWebComponent } from './network/reconfigureAgent/common/reconfigureAgentTypeForm';
import { ReconfigureAgentSchedulerFormWebComponent } from './network/reconfigureAgent/common/reconfigureAgentShedulerForm';
import { InstallAgentPanelWebComponent } from './network/installAgent/installAgentPanel';
import { InstallAgentAdditionalTargetsFormWebComponent } from './network/installAgent/common/installAgentAdditionalTargetsForm';
import { CredentialsManagerGridWebComponent } from './network/installAgent/common/credentialsManagerGrid';
import { DownloadTypeFormWebComponent } from './configuration/update/staging/downloadTypeForm';
import { GzHeaderUiWebComponent, GzHeaderWebComponent } from './ui/gzHeader';
import { UserRoleWebComponent } from './ui/gzHeader/ui/userRole';
import { GzDashboardAppWebComponent } from './genericDashboard/gzDashboardApp';
import { GzDashboardActionsToolbarWebComponent } from './genericDashboard/gzDashboardActionsToolbar';
import { GzDashboardFiltersBarWebComponent } from './genericDashboard/gzDashboardFilters';
import { GzHealthDashboardOverviewWebComponent } from './healthDashboard/widgetTemplates/overviewTemplate';
import { GzGenericWidget } from './genericDashboard/gzGenericWidget';
import { GzWidgetSectionItemWebComponent } from './ui/gzWidgetSectionItem';
import { GzWidgetHeaderItemWebComponent } from './ui/gzWidgetHeaderItem';
import { GzHealthDashboardLicensesWebComponent } from './healthDashboard/widgetTemplates/licenses';
import { GzWidgetProductItemWebComponent } from './ui/gzWidgetProductItem';
import { PatchManagementWebComponent } from './healthDashboard/widgetTemplates/patchManagement';
import { SecurityServerStatusWebComponent } from './healthDashboard/widgetTemplates/securityServerStatus';
import { EndpointModuleStatusWebComponent } from './healthDashboard/widgetTemplates/endpointModuleStatus';
import { InventoryTemplateWebComponent } from './healthDashboard/widgetTemplates/inventory';
import { GzInventoryItemWebComponent } from './ui/gzInventoryItem';
import { GzDashboardTitleWithFeedBackToolbarWebComponent } from './genericDashboard/gzDashboardTitleWithFeedBackToolbar';
import { GzDashboardResetViewWebComponent } from './genericDashboard/gzDashboardResetView';
import { GzNetworkAttackWebComponent } from './executiveSummary/widgetTemplates/networkAttackTechniques';
import { GzTopThreatsWebComponent } from './executiveSummary/widgetTemplates/topThreatsBlocked';
import { GzWebsitesBlockedWebComponent } from './executiveSummary/widgetTemplates/websitesBlocked';
import { GzInventoryWebComponent } from './executiveSummary/widgetTemplates/inventory';
import { GzThreatsBreakdownWebComponent } from './executiveSummary/widgetTemplates/threatsBreakdown';
import { GzIncidentsStatusWebComponent } from './executiveSummary/widgetTemplates/incidentsStatus';
import { GzRemediationActionsWebComponent } from './executiveSummary/widgetTemplates/remediationActions';
import { GzCompanyRiskScoreWebComponent } from './executiveSummary/widgetTemplates/companyRiskScore';
import { GzAccessDataProtectionWebComponent } from './executiveSummary/widgetTemplates/accessDataProtection';
import { GzOverviewWebComponent } from './executiveSummary/widgetTemplates/overview';
import { GzEndpointModulesStatusWebComponent } from './executiveSummary/widgetTemplates/endpointModulesStatus';
import { CustomRulesWebComponent } from './customRules/customRulesGrid';
import { CustomRulesSidePanelWebComponent } from './customRules/customRulesSidePanel';
import { CustomRulesGeneralWebComponent } from './customRules/customRulesGeneral';
import { CustomRulesRuleOutcomeWebComponent } from './customRules/customRulesRuleOutcome';
import { CustomRulesTargetsWebComponent } from './customRules/customRulesTargets';
import { GzAddRuleWebComponent, GzRuleCriteriaWebComponent } from './customRules/addRule';
import { GzYaraDefinitionWebComponent } from './customRules/addRule/component/yaraDefinition';
import { GzComplexSearchWebComponent, GzCustomInputSearchWebComponent } from './ui/gzComplexSearch';
import {
  RuleTargetsWebComponent,
  SelectedTagsWebComponent,
  EndpointTagWebComponent,
} from './customRules/addRule/component/ruleTargets';

import { GzHealthDashboardMacOsPermissionsWebComponent } from './healthDashboard/widgetTemplates/insightsTemplates/component/GzHealthDashboardMacOsPermissionsWebComponent';
import { GzInProductTrialsVideoWebComponent } from './productTrials/common/gzTrialVideo';
import { GzComplexEnumFilterWebComponent } from './ui/gzComplexEnumFilter';
import { HealthDashboardInfoOverlay } from './healthDashboard/gzDashboardInfoOverlay';
import { GridCellLinkWebComponent } from './edr/incidentsGrid/uiElements/gridCellLink';
import { GzComplexEnumListWebComponent } from './ui/gzComplexEnumList';
import { BackendEnumFilterWebComponent } from './filters/backendEnumFilter';

import { GzFontSizeChangerWebComponent } from './ui/gzFontSizeChanger';

import { GzIconWebComponent } from './ui/gzIcon';
import { GzHelpAndSupportWebComponent } from './ui/gzHelpAndSupport';
import { IntegrationInformationWebComponent } from './xdr/integrationInformation';
import { FormGroup } from './ui/gzForm/formGroup/form-group';
import { WebAccessControlSchedulerComponent } from './configurationProfilesApp/webAccessControlSchedulerApp';
import { WebAccessControlSchedulerFormComponent } from './configurationProfilesApp/webAccessControlSchedulerForm';
import { GzHealthDashboardProductUpdateStatusWebComponent } from './healthDashboard/widgetTemplates/insightsTemplates';
import { GzHealthDashboardSignatureUpdateStatusWebComponent } from './healthDashboard/widgetTemplates/insightsTemplates';
import { GzGeneralDonutChartWebComponent } from './ui/gzGeneralDonutChart';
import { RiskIncidentOverviewItemWebComponent } from './xdr/riskIncidentOverviewItem';
import { RiskIncidentPanelWebComponent } from './xdr/riskIncidentPanel';
import { RiskIncidentOverviewSectionWebComponent } from './xdr/riskIncidentOverviewSection/component/RiskIncidentOverviewSectionWebComponent';
import { GzTextAnimationWebComponent } from './ui/gzTextAnimation';
import { GzChatCardWebComponent } from './aiChat/gzChatCard';
import { AiChatWebComponent } from './aiChat/aiChatLayout';
import { GzChatIncidentUpdateWebComponent } from './aiChat/gzChatIncidentUpdate';
import { GzStarRatingWebComponent } from './ui/gzStarRating';
import { GzAiFeedbackWebComponent } from './aiChat/gzAiFeedback';
import { GzTextareaWithSuggestionsWebComponent } from './ui/gzTextareaWithSuggestions';
import { GzLabelSwitchWebComponent } from './ui/gzLabelSwitch';
import { GzGeneralChartWebComponent } from './ui/gzGeneralChart';
import { GzPriceDiscountWebComponent } from './ui/gzPriceDiscount';
import { GzPurchaseCardLayoutWebComponent } from './company/myCompany/purchase/purchasePage/gzPurchaseCardLayout';
import { GzIncrementInputWebComponent } from './ui/gzIncrementInput';
import { VulnerabilitiesAppWebComponent } from './riskManagement/vulnerabilitiesApp';
import { MisconfigurationsAppWebComponent } from './riskManagement/misconfigurationsApp';
import { UserBehaviorRisksAppWebComponent } from './riskManagement/userBehaviorRisksApp';
import { UsersAppWebComponent } from './riskManagement/usersApp';
import { UserBehaviorRisksSideMenuWebComponent } from './riskManagement/sideMenus/userBehaviorRisksSideMenu';
import { DevicesAppWebComponent } from './riskManagement/devicesApp';
import { MisconfigurationsSideMenuWebComponent } from './riskManagement/sideMenus/misconfigurationsSideMenu';
import { VulnerabilitiesSideMenuWebComponent } from './riskManagement/sideMenus/vulnerabilitiesSideMenu';
import { GzPurchasePageWebComponent } from './company/myCompany/purchase/purchasePage/gzPurchasePage';
import { GzLandingPageAppWebComponent } from './landingPage';
import { LandingPageTemplateWebComponent } from './landingPageTemplate';
import { LpMockWidgetsWebComponent } from './landingPageTemplate/widgets/landingPageMockWidgets';
import { LatestNewsCarouselWebComponent } from './landingPageTemplate/widgets/latestNews/latestNewsCarousel';
import { LatestNewsCardWebComponent } from './landingPageTemplate/widgets/latestNews/latestNewsCard';
import { GoToFeatureWebComponent } from './landingPageTemplate/widgets/goToFeature';
import { WelcomeWebComponent } from './landingPageTemplate/widgets/welcome';
import { MasterclassWebComponent } from './landingPageTemplate/widgets/masterclass';
import { SsoSingleIntegrationWebComponent } from './landingPageTemplate/widgets/ssoSingleIntegration';
import { ProductTrialsWebComponent } from './landingPageTemplate/widgets/productTrials';
import { SsoIntegrationWidgetWebComponent } from './landingPageTemplate/widgets/ssoIntegration';
import { GzAvailableItemsCardWebComponent } from './aiChat/gzAvailableItemsCard';
import { GzMegaMenuWebComponent } from './ui/gzMegaMenu';
import { ContextMenuOverlayElement } from './ui/gzContextMenuOverlay';
import { GzEasmVulnerableServersWebComponent } from './easm/widgets/vulnerableServers';
import { EasmAssetsInventoryGridWebComponent } from './easm/assetsInventoryGrid';
import { EasmArtifactsInventoryGridWebComponent } from './easm/artifactsInventoryGrid';
import { GzEasmCertificateExpirationWebComponent } from './easm/widgets/certificateExpiration';
import { GzDonutChartWidgetWebComponent } from './ui/gzDonutChartWidget';
import { GzMultiLevelListWebComponent } from './ui/gzMultiLevelList';
import { AntimalwareAntiTamperingPanelWebComponent } from './policies/antiTampering';
import { UsersSideMenuWebComponent } from './riskManagement/sideMenus/usersSideMenu';
import { DevicesSideMenuWebComponent } from './riskManagement/sideMenus/devicesSideMenu';
import { SearchableAccordionsPanelWebComponent } from './ui/gzSearchableAccordionsPanel';
import { SearchableAccordionsViewWebComponent } from './ui/gzSearchableAccordionsView';
import { GzMapWithBubblesChartWebComponent } from './ui/gzMapWithBubblesChart';
import { GzEasmGenericTopDataWebComponent } from './easm/widgets/genericTopData';
import { GzEasmVulnerableServicesWebComponent } from './easm/widgets/vulnerableServices';
import { GzEasmOpenPortsWebComponent } from './easm/widgets/openPorts';
import { GzEasmCriticalVulnerabilitiesWebComponent } from './easm/widgets/criticalVulnerabilities';
import { GzEasmServicesPerProtocolWebComponent } from './easm/widgets/servicesPerProtocol';
import { GzEasmArtifactsInventoryWebComponent } from './easm/widgets/dashboardInventory';
import { GzEasmMostRecentAssetsWebComponent } from './easm/widgets/mostRecentAssets';
import { GzCollapsiblePanelWebComponent } from './ui/gzCollapsiblePanel';
import { GzDataTableWebComponent } from './ui/gzDataTable';
import { DataTableFormStory } from './ui/gzDataTable/mocks/formStory';
import { NetworkAppContainerWebComponent } from './networkV2/networkAppContainer';
import { NetworkV2AppWebComponent } from './networkV2App';
import { GzGenericOverlayWebComponent } from './ui/gzGenericOverlay';
import { GenericOverlayElement } from './ui/gzGenericOverlay';
import { DeviceDetailsWebComponent } from './riskManagement/sideMenus/components/deviceDetails';
import { DeviceExtraDetailsWebComponent } from './riskManagement/sideMenus/components/deviceExtraDetails';
import { UserDetailsWebComponent } from './riskManagement/sideMenus/components/userDetails';
import { UserExtraDetailsWebComponent } from './riskManagement/sideMenus/components/userExtraDetails';
import { ApplicationCveListWebComponent } from './applicationCveList';
import { GzEasmDnsRecordsWebComponent } from './easm/widgets/dnsRecords';
import { EasmScanConfigurationWebComponent } from './easm/scanConfiguration/easmScanConfiguration';
import { EasmScanConfigurationItemFormWebComponent } from './easm/scanConfiguration/easmScanConfigurationItemForm';
import { EasmScanConfigurationAssetGridWebComponent } from './easm/scanConfiguration/easmScanConfigurationAssetGrid';
import { EasmScanConfigurationSchedulerWebComponent } from './easm/scanConfiguration/easmScanConfigurationScheduler';
import { GzEASMSideMenuWebComponent } from './easm/easmSideMenu';
import { SuspectedActorsCardWebComponent } from './xdr/suspectedActorsCard';
import { GzDoubleColumnDetailsWebComponent } from './ui/gzDoubleColumnDetails';
import { GzBulletWebComponent } from './ui/gzBullet';
import { GzEasmAssetsPerWeekWebComponent } from './easm/widgets/assetsPerWeek';
import { GzEasmVulnerabilitiesPerWeekWebComponent } from './easm/widgets/vulnerabilitiesPerWeek';
import { GzEasmAsnMapReportsWebComponent } from './easm/widgets/asnMapReports';
import { EasmRelatedFindingsWebComponent } from './easm/easmRelatedFindings';
import { MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent } from './maintenanceWindows/maintenanceWindowManuallyApprovedPatchesSelector';
import { GzPolicyPanelAccordionTemplateWebComponent } from './policies/common/policyPanel/uiSettings/accordionTemplate';
import { GzSearchablePolicyPanelWebComponent } from './policies/endpoints/policyPanel/searchableComponents/searchablePolicyPanel';
import { GzSearchablePolicyPanelViewWebComponent } from './policies/endpoints/policyPanel/searchableComponents/searchablePolicyPanelView';
import { GzPolicyPanelAccordionButtonsWebComponent } from './policies/common/policyPanel/uiSettings/accordionButtons';
import { PolicyPanelManager } from './policies/endpoints/policyPanel/PolicyPanelManager';
import { GzIndicatorsOfRiskGeneralWebComponent } from './policies/endpoints/policyPanel/uiSettings/indicatorsOfRisk/general';
import { GzBlocklistRulesGeneralWebComponent } from './policies/endpoints/policyPanel/uiSettings/blocklistRules/general';
import { GzEdrSensorGeneralWebComponent } from './policies/endpoints/policyPanel/uiSettings/edrSensor/general';
import { GzIntegrityMonitorRealTimeWebComponent } from './policies/endpoints/policyPanel/uiSettings/integrityMonitor/realTime';
import { GzIntegrityMonitorRuleSetsWebComponent } from './policies/endpoints/policyPanel/uiSettings/integrityMonitor/ruleSetsSection';
import { GzPatchManagementGeneralWebComponent } from './policies/endpoints/policyPanel/uiSettings/patchManagemnet/general';
import { PolicyDependenciesContainer } from './policies/common/policyPanel/uiSettings/dependencies/PolicyDependenciesContainer';
import { GzMaintenanceWindowsContainerWebComponent } from './policies/endpoints/policyPanel/uiSettings/patchManagemnet/helpers/maintenanceWindowsContainer';
import { GzMaintenanceWindowSummariesWebComponent } from './policies/endpoints/policyPanel/uiSettings/patchManagemnet/helpers/maintenanceWindowSummaries';
import { GzMaintenanceWindowSummaryWebComponent } from './policies/endpoints/policyPanel/uiSettings/patchManagemnet/helpers/maintenanceWindowSummary';
import { GzStorageProtectionIcapWebComponent } from './policies/endpoints/policyPanel/uiSettings/storageProtection/icap';
import { GzStorageProtectionExclusionsWebComponent } from './policies/endpoints/policyPanel/uiSettings/storageProtection/exclusions';
import { GzStorageProtectionExclusionsGridWrapperWebComponent } from './policies/endpoints/policyPanel/uiSettings/storageProtection/exclusions/gridComponents/GzStorageProtectionExclusionsGridWebComponent';
import { GzStorageProtectionExclusionItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/storageProtection/exclusions/gridComponents/GzStorageProtectionExclusionItemFormWebComponent';
import { GzEncryptionGeneralWebComponent } from './policies/endpoints/policyPanel/uiSettings/encryption/general';
import { GzEncryptionExclusionsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/encryption/general/gridComponents/GzEncryptionExclusionsGridWebComponent';
import { GzEncryptionExclusionItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/encryption/general/gridComponents/GzEncryptionExclusionItemFormWebComponent';
import { ComplianceStandardsWebComponent } from './riskManagement/sideMenus/components/complianceStandards';
import { NetworkPopUpFooterContentWebComponent } from './networkV2/networkPopUps/popUps/NetworkPopUpFooterContentWebComponent';
import { GzMalwareScanWebComponent } from './networkV2/networkPopUps/popUps/malware/component/GzMalwareScanWebComponent';
import { NetworkTreeWebComponent } from './networkV2/networkTree';
import { GzNetworkTreeSearchWebComponent } from './networkV2/networkTreeSearch/component/GzNetworkTreeSearchWebComponent';
import { IocScanIndicatorWebComponent } from './networkV2/networkPopUps/popUps/ioc/component/internalComponents/iocScanIndicator';
import { GzNetworkFeedbackFormWebComponent } from './networkV2/networkPopUps/popUps/networkFeedbackForm';
import { GzPolicyPanelAccordionNavigationHeaderWebComponent } from './policies/common/policyPanel/uiSettings/accordionNavigationHeader';
import { GzCustomTemplateListWebComponent } from './ui/gzCustomTemplateList';
import { SubmitToSandboxPanelWebComponent } from './network/submitToSandbox/submitToSandboxPanel';
import { SubmitToSandboxSamplesFormWebComponent } from './network/submitToSandbox/common/submitToSandboxSamplesForm';
import { SubmitToSandboxSettingsFormWebComponent } from './network/submitToSandbox/common/submitToSandboxSettingsForm';
import { GzInputTextGridWebComponent } from './ui/gzInputTextGrid';
import { CloudStagingListWebComponent } from './configurationProfilesApp/cloudStagingList';
import { CloudStagingSideBarWebComponent } from './configurationProfilesApp/cloudStagingSideBar';
import { GzChatNoticeWebComponent } from './aiChat/gzChatNotice';
import { LiveSearchWebComponent } from './policies/endpoints/policyPanel/uiSettings/liveSearch/general';
import { GzIntegrationsMarketplaceCardWebComponent } from './integrationsMarketplace/gzIntegrationsMarketplaceCard';
import { GzSelectionCardWebComponent, GzSelectionCardGroupWebComponent } from './ui/gzSelectionCardGroup';
import { GzSelectableTableRowGroupWebComponent } from './ui/gzSelectableTableRowGroup';
import { DeviceControlRulesWebComponent } from './policies/endpoints/policyPanel/uiSettings/deviceControl/rules';
import { GzDeviceControlRuleGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/deviceControl/rules/gridComponents/GzDeviceControlRuleGridWebComponent';
import { GzRelayCommunicationWebComponent } from './policies/endpoints/policyPanel/uiSettings/relay/communication';
import { GzRelayUpdateLocationsTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/relay/update/gridComponents/GzRelayUpdateLocationsTableWebComponent';
import { GzRelayUpdateLocationItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/relay/update/gridComponents/GzRelayUpdateLocationItemFormWebComponent';
import { GzRelayCommunicationWhitelistTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/relay/communication/gridComponents/GzRelayCommunicationWhitelistTableWebComponent';
import { GzRelayCommunicationWhitelistItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/relay/communication/gridComponents/GzRelayCommunicationWhitelistItemFormWebComponent';
import { GzRelayUpdateWebComponent } from './policies/endpoints/policyPanel/uiSettings/relay/update';
import { GzExchangeScanTaskWebComponent } from './networkV2/networkPopUps/popUps/exchangeScanTask/gzExchangeScanTask';
import { GzInputNumberWithDropdownWebComponent } from './networkV2/networkPopUps/popUps/exchangeScanTask/gzInputNumberWithDropdown';
import { GroupAttributionIocSidePanelWebComponent } from './xdr/groupAttributionIocSidePanel';
import { ActorCardWebComponent } from './xdr/actorCard';
import { GroupAttributionMitreSidePanelWebComponent } from './xdr/groupAttributionMitreSidePanel';
import { GroupAttributionCveSidePanelWebComponent } from './xdr/groupAttributionCveSidePanel';
import { GzIzIntegrationStatusWebComponent } from './company/common/gzIzIntegrationStatus';
import { GzDarkModeToggleWebComponent } from './ui/gzDarkModeToggle';
import { GzLocalSandboxInstanceWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/common/localSandbox';
import { GzProxyConfigurationWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/common/proxyConfiguration';
import { GzContentPrefilteringWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/common/contentPrefiltering';
import { GzDetonationProfileWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/common/detonationProfile';
import { GzSandboxEndpointSensorWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/endpointSensor';
import { GzRemediationActionWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/common/remediationAction';
import { GzFileSizesWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/common/fileSizes';
import { GzSandboxNetworkSensorWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/networkSensor';
import { GzSandboxIcapSensorWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/icapSensor';
import { GzSandboxManagerWebComponent } from './policies/endpoints/policyPanel/uiSettings/sandbox/sandboxManager';
import { GzSelectedListWebComponent } from './ui/gzSelectedList';
import { GzSelectedListItemWebComponent } from './ui/gzSelectedListItem';
import { GzSelectedListItemGeneratorWebComponent } from './ui/gzSelectedListItemGenerator';
import { IntegrationsMarketplaceAppContainerWebComponent } from './integrationsMarketplace/integrationsMarketplaceAppContainer';
import { IntegrationsMarketplaceGridInstalledWebComponent } from './integrationsMarketplace/integrationsMarketplaceGridInstalled';
import { IntegrationsMarketplaceGridAvailableWebComponent } from './integrationsMarketplace/integrationsMarketplaceGridAvailable';
import { SaveIntegrationWebComponent } from './integrationsMarketplace/saveIntegration';
import { VcenterWebComponent } from './integrationsMarketplace/integrations/vcenter';
import { NetworkScrollableWrapperWebComponent } from './networkV2/networkScrollableWrapper';
import { ComplianceAppWebComponent } from './compliance/complianceApp';
import { ComplianceOverviewWebComponent } from './compliance/complianceOverview';
import { BreachPathAppWebComponent } from './breachPath/breachPathApp';
import { BreachPathDetailsWebComponent } from './breachPath/breachPathDetails';
import { BreachPathGraphIconWebComponent } from './breachPath/breachPathGraphIcon';
import { BreachPathGraphNodeTypeWebComponent } from './breachPath/breachPathGraphNodeType';
import { GzApplicationControlGeneralWebComponent } from './policies/endpoints/policyPanel/uiSettings/applicationControl/general';
import { GzApplicationControlRulesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/applicationControl/general/gridComponents/GzApplicationControlRulesGridWebComponent';
import { GzRuleContainerWebComponent } from './policies/endpoints/policyPanel/uiSettings/deviceControl/helpers/ruleContainer';
import { DeviceControlExclusionsWebComponent } from './policies/endpoints/policyPanel/uiSettings/deviceControl/exclusions';
import { GzDeviceControlExclusionsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/deviceControl/exclusions/gridComponents/GzDeviceControlExclusionsGridWebComponent';
import { ManualAddExceptionContainerWebComponent } from './policies/endpoints/policyPanel/uiSettings/deviceControl/helpers/manualAddExceptionContainer';
import { DiscoveredDevicesAddExceptionContainerWebComponent } from './policies/endpoints/policyPanel/uiSettings/deviceControl/helpers/discoveredDevicesAddExceptionContainer';
import { GzCarouselInfoCardWebComponent } from './ui/gzCarouselInfoCard';
import { CarouselInfoOverlayStory } from './ui/gzCarouselInfoCard/mocks/overlayStory';
import { DiscoveredDevicesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/deviceControl/helpers/discoveredDevicesAddExceptionContainer/gridComponents/discoveredDevicesGridWebComponent/component/DiscoveredDevicesGridWebComponent';
import { GzApplicationControlTargetsTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/applicationControl/helpers/rulesItemForm/gridComponents/GzApplicationControlTargetsTableWebComponent';
import { GzApplicationControlTargetItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/applicationControl/helpers/rulesItemForm/gridComponents/GzApplicationControlTargetItemFormWebComponent';
import { GzRepairAgentWebComponent } from './networkV2/networkPopUps/popUps/repairAgent/component/GzRepairAgentWebComponent';
import { GzIsolateEndpointTaskWebComponent } from './networkV2/networkPopUps/popUps/isolateEndpoint/gzIsolateEndpointTask';
import { GzRemoveFromIsolationTaskWebComponent } from './networkV2/networkPopUps/popUps/removeFromIsolation/gzRemoveFromIsolationTask';
import { GzUninstallAgentWebComponent } from './networkV2/networkPopUps/popUps/uninstallAgent';
import { GzGoldenImageAssignationWebComponent } from './networkV2/networkPopUps/popUps/goldenImage/component/GzGoldenImageAssignationWebComponent';
import { CategoriesSideMenuWebComponent } from './sideMenus/categoriesSideMenu';
import { GzSchedulerWebComponent } from './ui/gzScheduler';
import { TimeRangeSchema } from '@nirvana/shared/dtos/types/shared/time';
import { ImportOptionsWebComponent } from './company/common/mdrContactDetails/importOptions';
import { MdrContactDetailsFormWebComponent } from './company/common/mdrContactDetails/mdrContactDetailsForm';
import { ContactDetailsSectionWebComponent } from './company/common/mdrContactDetails/mdrContactDetailsSection';
import { MdrSecurityTelemetryExclusionsGridWebComponent } from './mdr/mdrSecurityTelemetryExclusionsGrid';
import { AtlassianAuditComponent } from './xdr/sensors/atlassian/atlassianAudit';
import { AtlassianJiraConfluenceComponent } from './xdr/sensors/atlassian/atlassianJiraConfluence';
import { AtlassianJiraConfluenceGridWebComponent } from './xdr/sensors/atlassian/atlassianJiraConfluenceGrid';
import { GzNsxWebComponent } from './policies/endpoints/policyPanel/uiSettings/nsx/general';
import { EditPolicyAssignmentPanelWebComponent } from './configurationProfilesApp/editPolicyAssignmentPanel';
import { GzFirewallSettingsExclusionsTableWrapperWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/settings/gridComponents/GzFirewallSettingsExclusionsTableWebComponent';
import { GzFirewallSettingsExclusionItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/settings/gridComponents/GzFirewallSettingsExclusionItemFormWebComponent';
import { GzFirewallSettingsWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/settings';
import { GzFirewallNetworkTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/network/gridComponents/networks/GzFirewallNetworkTableWebComponent';
import { GzFirewallNetworkItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/network/gridComponents/networks/GzFirewallNetworkItemFormWebComponent';
import { GzFirewallAdaptersTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/network/gridComponents/adapters/GzFirewallAdaptersTableWebComponent';
import { GzFirewallNetworkWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/network';
import { GzFirewallAdvancedRulesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/advanced/gridComponents/GzFirewallAdvancedRulesGridWebComponent';
import { GzFirewallAdvancedWebComponent } from './policies/endpoints/policyPanel/uiSettings/firewall/advanced';
import { GzBuyProductCardWebComponent } from './productTrials/b2b/buyProductCard';
import { GzContentControlTrafficExclusionItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/traffic/gridComponents/GzContentControlTrafficExclusionItemFormWebComponent';
import { GzContentControlTrafficExclusionsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/traffic/gridComponents/GzContentControlTrafficExclusionsGridWebComponent';
import { GzContentControlTrafficWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/traffic';
import { GzContentControlDataProtectionWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/dataProtection';
import { GzContentControlNetworkMonitorWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/networkMonitor';
import { GzContentControlWebAccessExceptionsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/web/gridComponents/webAccessRules/GzContentControlWebAccessExceptionsGridWebComponent';
import { GzContentControlWebAccessExceptionsItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/web/gridComponents/webAccessRules/GzContentControlWebAccessExceptionsItemFormWebComponent';
import { GzContentControlDataProtectionRulesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/web/gridComponents/dataProtectionRules/GzContentControlDataProtectionRulesGridWebComponent';
import { GzContentControlDataProtectionExclusionsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/web/gridComponents/dataProtectionExclusions/GzContentControlDataProtectionExclusionsGridWebComponent';
import { GzContentControlApplicationRulesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/web/gridComponents/applicationRules/GzContentControlApplicationRulesGridWebComponent';
import { GzContentControlWebWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/web';
import { GzContentControlDataProtectionRulesLightGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/contentControl/web/gridComponents/dataProtectionExclusions/rulesItemForm/dataProtectionRules/GzContentControlDataProtectionRulesLightGridWebComponent';
import { AttackSurfaceReductionPotentialWebComponent } from './phasrDashboard/widgetTemplates/attackSurfaceReductionPotential';
import { PhasrDetectedIncidentsWebComponent } from './phasrDashboard/widgetTemplates/phasrDetectedIncidents';
import { GatheringDataInfoWebComponent } from './phasrDashboard/widgetTemplates/gatheringDataInfo';
import { GzWidgetSectionWithIconsAndPercentageItemWebComponent } from './ui/gzWidgetSectionWithIconsAndPercentageItem';
import {
  PhasrCategoriesWidgetTemplateWebComponent,
  PhasrTamperingToolsWebComponent,
  PhasrRemoteAdminToolsWebComponent,
  PhasrMinersWebComponent,
  PhasrHackToolsWebComponent,
  PhasrOffLandBinariesWebComponent,
} from './phasrDashboard/widgetTemplates/phasrCategoriesWidgetTemplate';
import { PhasrTopRecommendationsWebComponent } from './phasrDashboard/widgetTemplates/phasrTopRecommendations';
import { GzDeleteEntityWebComponent } from './networkV2/networkPopUps/popUps/delete';
import { PhasrRecommendationsWebComponent } from './phasrRecommendations/phasrRecommandationsApp';
import { PhasrRecommendationsGridWebComponent } from './phasrRecommendations/phasrRecommendationsGrid';
import { PhasrSidePanelComponent } from './phasrSidePanel';
import { PhasrMonitoredRulesWebComponent } from './phasrMonitoredRules/phasrMonitoredRulesApp';
import { PhasrMonitoredRulesGridWebComponent } from './phasrMonitoredRules/phasrMonitoredRulesGrid';
import { PhasrMonitoredRulesDetailsPanelComponent } from './phasrMonitoredRules/phasrMonitoredRulesDetailsPanel';
import {
  GzMarkdownEditorWebComponent,
  GzMarkdownEditorPromptContentWebComponent,
  GzMarkdownEditorTextareaWebComponent,
} from './ui/gzMarkdownEditor';
import { GzAssignPolicyWebComponent } from './networkV2/networkPopUps/popUps/assignPolicy/component/GzAssignPolicyWebComponent';
import { ChildGroupsGridWebComponent } from './networkV2/networkPopUps/popUps/assignPolicy/childGroupsGrid';
import { TargetsGridWebComponent } from './networkV2/networkPopUps/popUps/assignPolicy/targetsGrid';
import { GzRiskScanActionWebComponent } from './networkV2/networkPopUps/popUps/riskScan/component/GzRiskScanActionWebComponent';
import { GzRestartEndpointWebComponent } from './networkV2/networkPopUps/popUps/restartTask/component/GzRestartEndpointWebComponent';
import { GzTimeRangeSliderWebComponent } from './ui/gzTimeRangeSlider';
import { GzMoveToActionWebComponent } from './networkV2/networkPopUps/popUps/moveTo/gzMoveToAction';
import { MdrCustomerPanelWebComponent } from './mdr/mdrCustomerPanel';
import { MdrCompaniesGridWebComponent } from './mdr/mdrCompaniesGrid';
import { GzAssignSecurityServersWebComponent } from './networkV2/networkPopUps/popUps/assignSecurityServers/component/GzAssignSecurityServersWebComponent';
import { GzSuspendProtectionWebComponent } from './networkV2/networkPopUps/popUps/suspendProtection/component/GzSuspendProtectionWebComponent';
import { GzResumeProtectionComponent } from './networkV2/networkPopUps/popUps/resumeProtection/component/GzResumeProtectionComponent';
import { GzEasmAssetsInventoryWebComponent } from './easm/widgets/assetsInventory/component/GzEasmAssetsInventoryWebComponent';

import { GzAntimalwareAntiTamperingWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/antiTampering';
import { GzAntimalwareOnAccessUnixPathsTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onAccess/gridComponents/GzAntimalwareOnAccessUnixPathsTableWebComponent';
import { GzAntimalwareOnAccessUnixPathsItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onAccess/gridComponents/GzAntimalwareOnAccessUnixPathsItemFormWebComponent';
import { GzAntimalwareOnAccessWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onAccess';
import { GzAntimalwareDynamicThreatDefenseWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/dynamicThreatDefense';
import { GzAntimalwareAntiExploitApplicationsTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/antiExploit/gridComponents/predefinedApplications/GzAntimalwareAntiExploitApplicationsTableWebComponent';
import { GzAntimalwareAntiExploitWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/antiExploit';
import { GzAntimalwareSecurityServersSvaIpsTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/securityServers/gridComponents/GzAntimalwareSecurityServersSvaIpsTableWebComponent';
import { GzAntimalwareSecurityServersSvaIpsItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/securityServers/gridComponents/GzAntimalwareSecurityServersSvaIpsItemFormWebComponent';
import { GzAntimalwareSecurityServersWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/securityServers';
import { GzAntimalwareOnExecuteWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onExecute';
import {
  GzCollapsibleTimelineWebComponent,
  GzCollapsibleTimelineGroupWebComponent,
  GzCollapsibleTimelineItemWebComponent,
  GzCollapsibleTimelineLoadMore,
  GzTimelineWebComponent,
} from './ui/gzCollapsibleTimeline';
import { GzExchangeProtectionGeneralWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/general';
import { GzExchangeProtectionAntiSpoofingGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/general/gridComponents/antiSpoofing/GzExchangeProtectionAntiSpoofingGridWebComponent';
import { GzExchangeProtectionUserGroupsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/general/gridComponents/userGroups/gzExchangeProtectionUserGroupsGrid';
import { GzExchangeAntimalwareRulesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antimalware/gridComponents/filteringRules/GzExchangeAntimalwareRulesGridWebComponent';
import { GzExchangeUserGroupsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/helpers/gridComponents/userGroupsWithSelection/GzExchangeUserGroupsGridWebComponent';
import { GzExchangeAntimalwareScanTasksGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antimalware/gridComponents/scanTasks/GzExchangeAntimalwareScanTasksGridWebComponent';
import { GzExchangeAntimalwareExclusionsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antimalware/gridComponents/exclusions/GzExchangeAntimalwareExclusionsGridWebComponent';
import { GzExchangeAntimalwareScanTaskExclusionsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antimalware/gridComponents/scanTasks/rulesItemForm/gridComponents/GzExchangeAntimalwareScanTaskExclusionsGridWebComponent';
import { GzExchangeAntimalwareScanTaskExclusionItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antimalware/gridComponents/scanTasks/rulesItemForm/gridComponents/GzExchangeAntimalwareScanTaskExclusionItemFormWebComponent';
import { GzExchangeAntimalwareWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antimalware';
import { GzExchangeContentControlAttachmentFilteringRulesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/contentControl/gridComponents/attachmentFilteringRules/GzExchangeContentControlAttachmentFilteringRulesGridWebComponent';
import { GzExchangeContentControlContentFilteringRulesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/contentControl/gridComponents/contentFilteringRules/GzExchangeContentControlContentFilteringRulesGridWebComponent';
import { GzExchangeContentControlContentFilteringByGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/contentControl/gridComponents/contentFilteringRules/rulesItemForm/gridComponents/GzExchangeContentControlContentFilteringByGridWebComponent';
import { GzExchangeContentControlContentFilteringByItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/contentControl/gridComponents/contentFilteringRules/rulesItemForm/gridComponents/GzExchangeContentControlContentFilteringByItemFormWebComponent';
import { GzExchangeContentControlWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/contentControl';
import { GzExchangeProtectionAntiSpoofingContainerWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/helpers/gzExchangeProtectionAntiSpoofingContainer/component/GzExchangeProtectionAntiSpoofingContainerWebComponent';
import { GzExchangeAntispamWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antispam';
import { GzExchangeAntispamSettingsTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antispam/gridComponents/settings/GzExchangeAntispamSettingsTableWebComponent';
import { GzExchangeAntispamSettingsItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antispam/gridComponents/settings/GzExchangeAntispamSettingsItemFormWebComponent';
import { GzExchangeAntispamRulesGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antispam/gridComponents/filtering/GzExchangeAntispamRulesGridWebComponent';
import { GzExchangeAntispamRulesFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/exchange/antispam/gridComponents/filtering/rulesItemForm';
import { PhasrListWebComponent, PhasrListItemWebComponent } from './phasrRecommendations/phasrList';
import { PhasrRecommendationSideMenuWebComponent } from './phasrSideMenus/phasrRecommendationSideMenu';
import { GzPhoneInputWebComponent } from './ui/gzPhoneInput';
import { GzSingleSelectListPhoneCodeWebComponent } from './ui/gzSingleSelectListPhoneCode';
import { GzSingleSelectPhoneCodeWebComponent } from './ui/gzSingleSelectPhoneCode';
import { WebAccessControlCustomPagesComponent } from './configurationProfilesApp/webAccessControlCustomPagesApp/';
import { WebAccessControlCustomPagesFormComponent } from './configurationProfilesApp/webAccessControlCustomPagesForm/';
import { PhasrRestrictedProfilesListWebComponent } from './phasrRecommendations/phasrRestrictedProfilesSelector/phasrRestrictedProfilesList';
import { PhasrRestrictedProfilesViewWebComponent } from './phasrRecommendations/phasrRestrictedProfilesSelector/phasrRestrictedProfilesView';
import { GzSelectableTableRowWebComponent } from './ui/gzSelectableTableRowGroup/component/GzSelectableTableRowWebComponent';
import { GzPageNavigationHeaderWebComponent } from './ui/gzPageNavigationHeader';
import { PatchesGridWebComponent } from './networkV2/networkPopUps/popUps/installPatches/component/internalComponents/patchesGrid';
import { GzAnimatedHighlightBoxWebComponent, GzAnimatedHighlightBoxManager } from './ui/gzAnimatedHighlightBox';
import { GzOperatingSystemFilterWebComponent } from './ui/gzOperatingSystem';
import { CveGridWebComponent } from './networkV2/networkPopUps/popUps/installPatches/component/internalComponents/cveGrid';
import { ProductsGridWebComponent } from './networkV2/networkPopUps/popUps/installPatches/component/internalComponents/productsGrid';
import { GzRmSeverity } from './riskManagement/ui/gzRmSeverity';
import { GzRmSeverityBar } from './riskManagement/ui/gzRmSeverityBar';
import { GzRmCompanyStateWidgetWebComponent } from './riskManagement/widgets/gzRmCompanyStateWidget';
import { GzRmScoreOverTimeWidgetWebComponent } from './riskManagement/widgets/gzRmScoreOverTimeWidget';
import { GzRmResourcesByOsWidgetWebComponent } from './riskManagement/widgets/gzRmResourcesByOsWidget';
import { GzRmScannedResourcesWidgetWebComponent } from './riskManagement/widgets/gzRmScannedResourcesWidget';
import { GzRmScannedIdentitiesWidgetWebComponent } from './riskManagement/widgets/gzRmScannedIdentitiesWidget';
import { GzRmTopFindingsSeverityWidgetWebComponent } from './riskManagement/widgets/gzRmTopFindingsSeverityWidget';
import { GzRmTopVulnerabilitiesSeverityWidgetWebComponent } from './riskManagement/widgets/gzRmTopVulnerabilitiesSeverityWidget';
import { GzRmTopIdentityRisksSeverityWidgetWebComponent } from './riskManagement/widgets/gzRmTopIdentityRisksSeverityWidget';
import { GzRmTopFindingsImpactWidgetWebComponent } from './riskManagement/widgets/gzRmTopFindingsImpactWidget';
import { GzRmTopVulnerabilitiesImpactWidgetWebComponent } from './riskManagement/widgets/gzRmTopVulnerabilitiesImpactWidget';
import { GzRmTopIdentityRisksImpactWidgetWebComponent } from './riskManagement/widgets/gzRmTopIdentityRisksImpactWidget';
import { GzRmVulnerabilitiesBreakdownWidgetWebComponent } from './riskManagement/widgets/gzRmVulnerabilitiesBreakdownWidget';
import { GzRmTopResourcesRiskWidgetWebComponent } from './riskManagement/widgets/gzRmTopResourcesRiskWidget';
import { GzRmTopIdentitiesRiskWidgetWebComponent } from './riskManagement/widgets/gzRmTopIdentitiesRiskWidget';
import { GzRmTopVulnerabilitiesIncidentsWidgetWebComponent } from './riskManagement/widgets/gzRmTopVulnerabilitiesIncidentsWidget';
import { GzRmTopResourcesIncidentsWidgetWebComponent } from './riskManagement/widgets/gzRmTopResourcesIncidentsWidget';
import { GzRmCvesSeverityWidgetWebComponent } from './riskManagement/widgets/gzRmCvesSeverityWidget';
import { GzRmApplicationsSeverityWidgetWebComponent } from './riskManagement/widgets/gzRmApplicationsSeverityWidget';
import { GzRmOldestVulnerabilitiesWidgetWebComponent } from './riskManagement/widgets/gzRmOldestVulnerabilitiesWidget';
import { GzRmZeroTrustWidgetWebComponent } from './riskManagement/widgets/gzRmZeroTrustWidget';
import { SetVmwareIntegratorWebComponent } from './networkV2/networkPopUps/popUps/setVmwareIntegrator';
import { UnsetVmwareIntegratorWebComponent } from './networkV2/networkPopUps/popUps/unsetVmwareIntegrator';
import { GzSingleSelectLoadedWebComponent } from './ui/gzSingleSelectLoaded';
import { PhasrApplyActionPanelWebComponent } from './phasrApplyActionPanel';
import { PhasrBehavioralProfilesComponent } from './phasrRecommendations/phasrBehavioralProfilesComponent';
import { GzAntimalwareOnDemandScanTasksGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/gridComponents/scanTasks/GzAntimalwareOnDemandScanTasksGridWebComponent';
import { GzAntimalwareOnDemandWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand';
import { GzAntimalwareOnDemandExclusionsTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/targetForm/gridComponents/exclusions/GzAntimalwareOnDemandExclusionsTableWebComponent';
import { GzAntimalwareOnDemandExclusionsItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/targetForm/gridComponents/exclusions/GzAntimalwareOnDemandExclusionsItemFormWebComponent';
import { GzAntimalwareOnDemandScanTargetTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/targetForm/gridComponents/scanTarget/GzAntimalwareOnDemandScanTargetTableWebComponent';
import { GzAntimalwareOnDemandScanTargetItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/targetForm/gridComponents/scanTarget/GzAntimalwareOnDemandScanTargetItemFormWebComponent';
import { GzAntimalwareExclusionsGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/exclusions/gridComponents/inPolicyExclusions/GzAntimalwareExclusionsGridWebComponent';
import { GzAntimalwareExclusionsItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/exclusions/gridComponents/inPolicyExclusions/GzAntimalwareExclusionsItemFormWebComponent';
import { GzAntimalwareExclusionsListsWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/exclusions/gridComponents/listsExclusions';
import { GzAntimalwareVendorsExclusionsListsWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/exclusions/gridComponents/vendorsListsExclusions';
import { GzAntimalwareSettingsWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/settings';
import { GzAntimalwareExclusionsWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/exclusions';
import { GzGeneralSecurityTelemetryWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/securityTelemetry';
import { GzGeneralCommunicationWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/communication';
import { GzEcsAssignmentGridWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/communication/gridComponents/endpointCommunicationAssignment/GzEcsAssignmentGridWebComponent';
import { GzEcsAssignmentItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/communication/gridComponents/endpointCommunicationAssignment/GzEcsAssignmentItemFormWebComponent';
import { GzGeneralDetailsWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/details';
import { GzGeneralNotificationsWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/notifications';
import { GzGeneralInheritanceRulesTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/inheritanceRules/gridComponents/GzGeneralInheritanceRulesTableWebComponent';
import { GzGeneralInheritanceRulesItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/inheritanceRules/gridComponents/GzGeneralInheritanceRulesItemFormWebComponent';
import { GzGeneralInheritanceRulesWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/inheritanceRules';
import { GzGeneralAdvancedWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/advanced';
import { GzGeneralUpdateWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/update';
import { GzGeneralUpdateLocationsTableWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/update/gridComponents/GzGeneralUpdateLocationsTableWebComponent';
import { GzGeneralUpdateLocationItemFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/general/update/gridComponents/GzGeneralUpdateLocationItemFormWebComponent';
import { GzAntimalwareOnDemandContextualScanFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/contextualScanForm';
import { GzAntimalwareOnDemandDeviceScanFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/deviceScanForm';
import { GzAntimalwareOnDemandScanTaskGeneralFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/generalForm/component/GzAntimalwareOnDemandScanTaskGeneralFormWebComponent';
import { GzAntimalwareOnDemandScanTaskOptionsFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/optionsForm';
import { GzAntimalwareOnDemandScanTaskTargetFormWebComponent } from './policies/endpoints/policyPanel/uiSettings/antimalware/onDemand/forms/targetForm';
import { GzRmIconsListWebComponent } from './riskManagement/ui/gzRmIconsList';
import { GzRmIconWebComponent } from './riskManagement/ui/gzRmIcon';
import { NetworkPopUpFactory, NetworkPopUpType } from './networkV2/networkPopUps/network.pop-up.factory';
import { GzSelectMenuWithButtonWebComponent } from './ui/gzSelectMenuWithButton';
import { GzHorizontalStackedBarChartWebComponent } from './ui/horizontalStackedBarChart';
import { GuidedToursManager } from './guidedTours/GuidedToursManager';
import { IzIntegrationWebComponent } from './izIntegration';
import { GzMultiGaugeWebComponent } from './ui/gzMultiGauge';
import { GzSeverityIconWebComponent } from './ui/gzSeverityIcon';

import { IncidentsActivityPanelWebComponent } from './xdr/incidentsActivityPanel';
import { AlertDetailsWebComponent } from './xdr/alertDetails';
import { AlertGroupDetailsSidepanelWebComponent } from './xdr/alertGroupDetailsSidepanel';
import { GzNavigationButtonWebComponent } from './networkV2/networkAppContainer/gzNavigationButton';
import { GridViewStatusChipWebComponent } from './grid/uiElements/gridViewStatusChip';
export {
  styles,
  DashboardAppWebComponent,
  CveGridWebComponent,
  ProductsGridWebComponent,
  NetworkTreeWebComponent,
  GzNetworkTreeSearchWebComponent,
  GzDashboardGridStackManagerWebComponent,
  GzMalwareScanWebComponent,
  DashboardWebComponent,
  MspEdrTrialReportWebComponent,
  OverviewWebComponent,
  NetworkPopUpFooterContentWebComponent,
  IocScanIndicatorWebComponent,
  TopThreatsWebComponent,
  ThreatsBreakdownWebComponent,
  RemediationsWebComponent,
  IncidentsWebComponent,
  IntegrityMonitorEventsWebComponent,
  IntegrityMonitorDetailsPanelWebComponent,
  IntegrityMonitorRealTimePanelWebComponent,
  IntegrityMonitorPolicyRuleSetsSectionWebComponent,
  IntegrityMonitorRulesAppWebComponent,
  IntegrityMonitorRulesSmartViewsWebComponent,
  IntegrityMonitorRulesGridWebComponent,
  IntegrityMonitorPauseWebComponent,
  IntegrityMonitorRuleSetFormWebComponent,
  IntegrityMonitorAssignRulesFormWebComponent,
  IntegrityMonitorDefaultRuleConfigurationWebComponent,
  IntegrityMonitorAddCustomRulePanelWebComponent,
  IntegrityMonitorCustomRuleMainFormWebComponent,
  IntegrityMonitorFileRuleFormWebComponent,
  IntegrityMonitorDirectoryRuleFormWebComponent,
  IntegrityMonitorRegistryKeyRuleFormWebComponent,
  IntegrityMonitorRegistryValueRuleFormWebComponent,
  IntegrityMonitorCustomRuleActionsFormWebComponent,
  IntegrityMonitorCustomRuleActionItemWebComponent,
  IntegrityMonitorInputWithChipsWebComponent,
  IntegrityMonitorFilePathFormFieldWebComponent,
  IntegrityMonitorDirectoryPathFormFieldWebComponent,
  InventoryTemplateWebComponent,
  GzSelectWebComponent,
  SelectOverlayElement,
  GzHealthDashboardUpdateStatusWebComponent,
  GzHealthDashboardEndpointIssuesWebComponent,
  GzHealthDashboardPoliciesWebComponent,
  GzHealthDashboardEndpointEncryptionWebComponent,
  GzEasmScheduleControllerWebComponent,
  GzGeneralDonutChartWebComponent,
  GzEasmArtifactsInventoryWebComponent,
  GzEasmMostRecentAssetsWebComponent,
  GzEASMSideMenuWebComponent,
  AccessDataProtectionComponent,
  GzGaugeWebComponent,
  EndpointModulesWebComponent,
  EndpointModulesStatusDetailsWebComponent,
  CompanyRiskScoreWebComponent,
  GzCounterWebComponent,
  GzProgressWebComponent,
  GzProgressThinWebComponent,
  WebsitesBlockedComponent,
  NetworkAttackWebComponent,
  GzLoaderWebComponent,
  GzTooltipWebComponent,
  GzTooltipBoxWebComponent,
  GzDashboardLoadingScreenWebComponent,
  GzDropdownWebComponent,
  GzDialogWebComponent,
  AlertsAppWebComponent,
  AlertsWebComponent,
  GzRadioWebComponent,
  GzRadioGroupWebComponent,
  GridViewWebComponent,
  GridFiltersWebComponent,
  GridFooterWebComponent,
  GzDropdownMenuWebComponent,
  GzButtonWebComponent,
  GzClearableInputWebComponent,
  GzInputSearchWebComponent,
  GzInputNumberWebComponent,
  GzTextareaWebComponent,
  GzInputFileWebComponent,
  GzCheckboxWebComponent,
  GzEnumFilterWebComponent,
  GzSideMenuWebComponent,
  GzEnumListWebComponent,
  GridSettingsWebComponent,
  GridSmartViewsWebComponent,
  CompanySelectorWebComponent,
  GzRemovableWebComponent,
  GzDatetimeFilterWebComponent,
  GzTitleWebComponent,
  GzToggleWebComponent,
  GzProgressSpinnerWebComponent,
  GzDateRangePickerWebComponent,
  GzImageRepoWebComponent,
  GzTabGroupWebComponent,
  GzTabWebComponent,
  MyCompanyPanelWebComponent,
  CompanyDetailsTabWebComponent,
  EditCompanyPanelWebComponent,
  GzFormFieldWebComponent,
  GzFormFieldToggleableWebComponent,
  GzInputErrorWebComponent,
  GzFormListWebComponent,
  GlobalExclusionsAppWebComponent,
  ConfigurationProfilesWebComponent,
  GlobalExclusionsWebComponent,
  ExclusionListsWebComponent,
  NewExclusionListWebComponent,
  ExclusionListFormWebComponent,
  ExclusionItemFormWebComponent,
  ExclusionItemGridWebComponent,
  ExportExclusionsPanelWebComponent,
  GzWizardWebComponent,
  GzWizardStepWebComponent,
  GzAccordionWebComponent,
  CompaniesGridWebComponent,
  BetaProgramSection,
  CompaniesAppWebComponent,
  CompanyAuthenticationTabWebComponent,
  CompanyBetaProgramsTabWebComponent,
  GzCopyToClipboardWebComponent,
  CompanyLicensingTabWebComponent,
  CompanyMspInProductTrialsTabWebComponent,
  ChangePartnerMenuWebComponent,
  AddProductMenuWebComponent,
  EditLicensingOptionsMenuWebComponent,
  PlansAndPurchaseTabWebComponent,
  GzIconButtonWebComponent,
  GzLabeledContentWebComponent,
  GzToastNotificationWebComponent,
  GzToastElement,
  GzListItemWebComponent,
  GridCellEditWebComponent,
  PoliciesSelectorWebComponent,
  ExclusionListSelectorWebComponent,
  GzTableWebComponent,
  GzBasicTableWebComponent,
  RemoteShellWebComponent,
  TerminalWebComponent,
  GzSplitButtonWebComponent,
  EndpointDetailsWebComponent,
  GzLinkWebComponent,
  PackagesAppWebComponent,
  DownloadKitButtonSelectorWebComponent,
  DownloadSecurityContainerWebComponent,
  DownloadK8sAgentWebComponent,
  PackagePanelWebComponent,
  PackageGeneralFormWebComponent,
  PackageModulesFormWebComponent,
  PackageScanModesFormWebComponent,
  PackageSettingsFormWebComponent,
  PackageMiscellaneousFormWebComponent,
  PackageDeployerFormWebComponent,
  PackageUseProxyFormWebComponent,
  DeployerGridWebComponent,
  ActivityGridWebComponent,
  AccountsGridWebComponent,
  AddAccountWebComponent,
  EditAccountWebComponent,
  AccountRoleAndPrivilegesWebComponent,
  AccountLoginSecurityWebComponent,
  AccountDetailsWebComponent,
  SensorsIntegrationsGridComponent,
  SensorsIntegrationDetailsPanelComponent,
  GzTextWebComponent,
  GzInfoBoxWebComponent,
  GzMultiSelectItemWebComponent,
  GzMultiSelectGroupWebComponent,
  GzTimePickerWebComponent,
  GzDatePickerWebComponent,
  ImportantMessagesWebComponent,
  GzPushBodyLayoutWebComponent,
  MaintenanceWindowsAppWebComponent,
  MaintenanceWindowFormWebComponent,
  MaintenanceWindowSelectorWebComponent,
  MaintenanceWindowPreviewPatchManagementWebComponent,
  MaintenanceWindowGridWebComponent,
  MaintenanceWindowFormPatchSpecificsWebComponent,
  MaintenanceWindowSchedulerWebComponent,
  MaintenanceWindowPatchManagementVendorProductSelectorWebComponent,
  MaintenanceWindowSimpleSchedulerWebComponent,
  RelayPatchCachingServersWebComponent,
  MaintenanceWindowRebootOptionsWebComponent,
  CompanyDetailsFormWebComponent,
  CreateCompanyPanelWebComponent,
  CompanyAuthenticationFormWebComponent,
  LicenseMainFormWebComponent,
  LicenseTrialSubFormWebComponent,
  LicenseFratSubFormWebComponent,
  LicensePrePaidSubFormWebComponent,
  LicenseBasicMonthlySubscriptionSubFormWebComponent,
  LicenseMonthlyLicenseTrialSubFormWebComponent,
  LicenseMonthlySubscriptionTrialSubFormWebComponent,
  LicenseMonthlySubscriptionSubFormWebComponent,
  LicenseMonthlyServicesFormWebComponent,
  LicenseMonthlyAddonsFormWebComponent,
  LicenseMonthlyOwnBundleFormWebComponent,
  LicenseMonthlyResellBundleFormWebComponent,
  LicenseMonthlyAvailableBundlesForAffectedDescendantsFormWebComponent,
  CustomFieldsFormWebComponent,
  InlineRowActionsWebComponent,
  IntegrationCreatePanelWebComponent,
  EditIntegrationWebComponent,
  IntegrationRequirementsWebComponent,
  IntegrationInformationWebComponent,
  IntegrationTypeCardWebComponent,
  SendFeedbackWebComponent,
  SelectIntegrationTypeWebComponent,
  IntegrationSelectCompanyWebComponent,
  IntegrationSavedSuccessWebComponent,
  GzCardWebComponent,
  O365MailWebComponent,
  O365AuditWebComponent,
  AtlassianAuditComponent,
  AtlassianJiraConfluenceComponent,
  AtlassianJiraConfluenceGridWebComponent,
  GzQueryInputWebComponent,
  XdrSearchQueryPanelWebComponent,
  XdrLiveSearchQueryPanelWebComponent,
  XdrSearchResultsPanelWebComponent,
  XdrSearchWebComponent,
  XdrSearchTabPanelComponent,
  XdrSearchLiveWebComponent,
  MaintenanceWindowsSideNavWebComponent,
  GzChipItemWebComponent,
  SummaryPanelWebComponent,
  DynamicColumnLayoutWebComponent,
  GzChipsGroupWebComponent,
  XdrOverviewWebComponent,
  TimelineItemWebComponent,
  TimelineGroupWebComponent,
  TacticsAndTechniquesWebComponent,
  GzFlexibleTableWebComponent,
  GzClipContentWebComponent,
  GzCollapsableContainerWebComponent,
  ResponseGridWebComponent,
  ResponsePanelWebComponent,
  ResponsePanelItemWebComponent,
  RiskIncidentPanelWebComponent,
  RiskIncidentOverviewSectionWebComponent,
  GzCompanyListWebComponent,
  GzCompanyFilterWebComponent,
  GzEndpointListWebComponent,
  GzEndpointFilterWebComponent,
  GzPaginationWebComponent,
  GridViewTitleWebComponent,
  ExchangeProtectionWebComponent,
  ComputersAndVirtualMachinesWebComponent,
  QuarantineComputersAndVirtualMachinesRestoreForm,
  QuarantineSaveFormWebComponent,
  AlertsDetailsPanelComponent,
  GridSelectionExtraOptionsWebComponent,
  LightGridWebComponent,
  GzJsonViewerWebComponent,
  MaintenanceWindowsDeleteDialogWebComponent,
  GzTreeWebComponent,
  GzNodeDirectorWebComponent,
  GzNodeRenameInputWebComponent,
  GzLoadMoreNodesButtonWebComponent,
  RawEventsConfigurationGridWebComponent,
  GridCellDefaultRendererWebComponent,
  NotesPanelWebComponent,
  NotesListWebComponent,
  NoteCardWebComponent,
  NoteEditorWebComponent,
  IncidentHistoryWebComponent,
  CardHistoryWebComponent,
  GzCountDownWebComponent,
  LiveSearchResultsGridComponent,
  GzSliderWebComponent,
  GenericGridSmartViewsWebComponent,
  GzDynamicFormWrapperWebComponent,
  GzDynamicFormInputWebComponent,
  GzRangeSliderInputWebComponent,
  GzSingleSelectWebComponent,
  GzSingleSelectListWebComponent,
  GzSingleSelectComplexWebComponent,
  GenericSmartViewsListWebComponent,
  TagsManagerGridWebComponent,
  TagsManagerWebComponent,
  TagPanelWebComponent,
  TagDetailsFormWebComponent,
  TagsNetworkFilterWebComponent,
  GzTagsEnumListWebComponent,
  GzTagsEnumFilterWebComponent,
  InlineTagFormWebComponent,
  IncidentsGridWebComponent,
  GzIconLabelWebComponent,
  IncidentsSideMenuWebComponent,
  OrganizationalImpactWebComponent,
  LiveSearchMetadataWebComponent,
  LiveSearchMetadataGridComponent,
  XdrIncidentDetailsWebComponent,
  EdrIncidentDetailsWebComponent,
  IncidentDetailsAnalysisSectionWebComponent,
  IncidentGeneralSectionWebComponent,
  PackagesGridWebComponent,
  IncidentAttackInfoWebComponent,
  GzLandingPageAppWebComponent,
  ShowMoreItemsWebComponent,
  IncidentDetailsDetectionsSectionWebComponent,
  IncidentDetailsTechniquesSectionWebComponent,
  ShowMoreItemsInBulkWebComponent,
  EdrResponseGridWebComponent,
  GridSummaryWebComponent,
  PackageSecurityServerAssignmentGridWebComponent,
  GzDashboardSmartViewsListWebComponent,
  GzDashboardSaveAsDialogContentWebComponent,
  GzDashboardFeedBackDialogContentWebComponent,
  GzDashboardDeleteViewDialogContentWebComponent,
  GzDashboardDiscardChangesDialogContentWebComponent,
  GzDashboardUnsavedChangesDialogContentWebComponent,
  GzDashboardSmartViewsToolbarWebComponent,
  GzEnumerationIconWebComponent,
  TargetsWebComponent,
  GzBannerWebComponent,
  MobileSecurityCompanyGridWebComponent,
  MobileSecurityCustomerViewWebComponent,
  CloudWorkloadSecurityCustomerViewWebComponent,
  MobileSecurityActivationEmailsDialogBodyWebComponent,
  GzInfoOverlayWebComponent,
  GzChipsGeneratorInputWebComponent,
  GzTrialProductItemWebComponent,
  GzTrialHomePageWebComponent,
  B2bLandingPageWebComponent,
  MspLandingPageWebComponent,
  GzInProductTrialsHeaderWebComponent,
  GzInProductTrialsVideoWebComponent,
  SchemaHelperWebComponent,
  TasksWebComponent,
  SubTasksWebComponent,
  InProductTrialsAppWebComponent,
  InProductTrialsOverlayContentWebComponent,
  MspInProductTrialsOverlayContentWebComponent,
  InProductTrialsOverlayWindowsAppWebComponent,
  MspInProductTrialsOverlayWindowsAppWebComponent,
  UploadWindowWebComponent,
  DownloadWindowWebComponent,
  GzDashboardMacroComponentWebComponent,
  GzBulkActionsBarWebComponent,
  ReconfigureAgentPanelWebComponent,
  ReconfigureAgentTypeFormWebComponent,
  ReconfigureAgentSchedulerFormWebComponent,
  InstallAgentPanelWebComponent,
  InstallAgentAdditionalTargetsFormWebComponent,
  CredentialsManagerGridWebComponent,
  DownloadTypeFormWebComponent,
  GzHeaderUiWebComponent,
  GzHeaderWebComponent,
  UserRoleWebComponent,
  GzDashboardActionsToolbarWebComponent,
  GzDashboardFiltersBarWebComponent,
  GzDashboardAppWebComponent,
  GzGenericWidget,
  GzHealthDashboardOverviewWebComponent,
  GzWidgetSectionItemWebComponent,
  RiskIncidentOverviewItemWebComponent,
  GzWidgetHeaderItemWebComponent,
  GzHealthDashboardLicensesWebComponent,
  GzWidgetProductItemWebComponent,
  PatchManagementWebComponent,
  GzHealthDashboardMacOsPermissionsWebComponent,
  EndpointModuleStatusWebComponent,
  SecurityServerStatusWebComponent,
  GzInventoryItemWebComponent,
  InventoryWebComponent,
  GzDashboardTitleWithFeedBackToolbarWebComponent,
  GzDashboardResetViewWebComponent,
  GzNetworkAttackWebComponent,
  GzTopThreatsWebComponent,
  GzWebsitesBlockedWebComponent,
  GzInventoryWebComponent,
  GzThreatsBreakdownWebComponent,
  GzIncidentsStatusWebComponent,
  GzRemediationActionsWebComponent,
  GzCompanyRiskScoreWebComponent,
  GzAccessDataProtectionWebComponent,
  GzOverviewWebComponent,
  GzEndpointModulesStatusWebComponent,
  CustomRulesWebComponent,
  CustomRulesSidePanelWebComponent,
  CustomRulesGeneralWebComponent,
  CustomRulesRuleOutcomeWebComponent,
  CustomRulesTargetsWebComponent,
  GzAddRuleWebComponent,
  GzRuleCriteriaWebComponent,
  GzYaraDefinitionWebComponent,
  RuleTargetsWebComponent,
  GzComplexSearchWebComponent,
  GzCustomInputSearchWebComponent,
  SelectedTagsWebComponent,
  EndpointTagWebComponent,
  GzComplexEnumFilterWebComponent,
  HealthDashboardInfoOverlay,
  GridCellLinkWebComponent,
  GzComplexEnumListWebComponent,
  BackendEnumFilterWebComponent,
  GzFontSizeChangerWebComponent,
  GzIconWebComponent,
  GzHelpAndSupportWebComponent,
  WebAccessControlSchedulerComponent,
  WebAccessControlSchedulerFormComponent,
  GzHealthDashboardProductUpdateStatusWebComponent,
  GzHealthDashboardSignatureUpdateStatusWebComponent,
  GzTextAnimationWebComponent,
  GzAvailableItemsCardWebComponent,
  GzChatCardWebComponent,
  AiChatWebComponent,
  GzTextareaWithSuggestionsWebComponent,
  GzChatIncidentUpdateWebComponent,
  GzStarRatingWebComponent,
  GzAiFeedbackWebComponent,
  GzLabelSwitchWebComponent,
  GzGeneralChartWebComponent,
  LandingPageTemplateWebComponent,
  LpMockWidgetsWebComponent,
  LatestNewsCarouselWebComponent,
  LatestNewsCardWebComponent,
  GoToFeatureWebComponent,
  WelcomeWebComponent,
  MasterclassWebComponent,
  SsoSingleIntegrationWebComponent,
  ProductTrialsWebComponent,
  SsoIntegrationWidgetWebComponent,
  GzEasmCertificateExpirationWebComponent,
  GzDonutChartWidgetWebComponent,
  GzPriceDiscountWebComponent,
  GzPurchaseCardLayoutWebComponent,
  GzIncrementInputWebComponent,
  GzPurchasePageWebComponent,
  GzBuyProductCardWebComponent,
  GzMultiLevelListWebComponent,
  ContextMenuOverlayElement,
  GzEasmVulnerableServersWebComponent,
  AntimalwareAntiTamperingPanelWebComponent,
  GzMegaMenuWebComponent,
  SearchableAccordionsPanelWebComponent,
  SearchableAccordionsViewWebComponent,
  EasmAssetsInventoryGridWebComponent,
  EasmArtifactsInventoryGridWebComponent,
  GzMapWithBubblesChartWebComponent,
  GzCollapsiblePanelWebComponent,
  GzDataTableWebComponent,
  DataTableFormStory,
  NetworkAppContainerWebComponent,
  NetworkV2AppWebComponent,
  GenericOverlayElement,
  GzGenericOverlayWebComponent,
  GzEasmAssetsInventoryWebComponent,
  GzEasmGenericTopDataWebComponent,
  GzEasmVulnerableServicesWebComponent,
  GzEasmOpenPortsWebComponent,
  GzEasmCriticalVulnerabilitiesWebComponent,
  GzEasmServicesPerProtocolWebComponent,
  GzEasmDnsRecordsWebComponent,
  EasmScanConfigurationWebComponent,
  EasmScanConfigurationItemFormWebComponent,
  EasmScanConfigurationAssetGridWebComponent,
  EasmScanConfigurationSchedulerWebComponent,
  SuspectedActorsCardWebComponent,
  GzExchangeScanTaskWebComponent,
  GzInputNumberWithDropdownWebComponent,
  GzDoubleColumnDetailsWebComponent,
  GzBulletWebComponent,
  MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent,
  GzEasmAssetsPerWeekWebComponent,
  GzEasmVulnerabilitiesPerWeekWebComponent,
  GzEasmAsnMapReportsWebComponent,
  EasmRelatedFindingsWebComponent,
  GzPolicyPanelAccordionButtonsWebComponent,
  GzPolicyPanelAccordionNavigationHeaderWebComponent,
  GzPolicyPanelAccordionTemplateWebComponent,
  GzSearchablePolicyPanelWebComponent,
  GzSearchablePolicyPanelViewWebComponent,
  GzIntegrityMonitorRealTimeWebComponent,
  GzIntegrityMonitorRuleSetsWebComponent,
  GzIndicatorsOfRiskGeneralWebComponent,
  GzBlocklistRulesGeneralWebComponent,
  GzEdrSensorGeneralWebComponent,
  GzPatchManagementGeneralWebComponent,
  GzMaintenanceWindowsContainerWebComponent,
  GzMaintenanceWindowSummariesWebComponent,
  GzMaintenanceWindowSummaryWebComponent,
  GzStorageProtectionIcapWebComponent,
  GzStorageProtectionExclusionsWebComponent,
  GzStorageProtectionExclusionsGridWrapperWebComponent,
  GzStorageProtectionExclusionItemFormWebComponent,
  GzEncryptionGeneralWebComponent,
  GzEncryptionExclusionsGridWebComponent,
  GzEncryptionExclusionItemFormWebComponent,
  ComplianceStandardsWebComponent,
  GzNetworkFeedbackFormWebComponent,
  GzCustomTemplateListWebComponent,
  SubmitToSandboxPanelWebComponent,
  SubmitToSandboxSamplesFormWebComponent,
  SubmitToSandboxSettingsFormWebComponent,
  GzInputTextGridWebComponent,
  DeviceControlRulesWebComponent,
  GzDeviceControlRuleGridWebComponent,
  GzChatNoticeWebComponent,
  LiveSearchWebComponent,
  GzIntegrationsMarketplaceCardWebComponent,
  GzSelectionCardWebComponent,
  GzSelectionCardGroupWebComponent,
  GzRuleContainerWebComponent,
  GzSelectableTableRowGroupWebComponent,
  GzSelectableTableRowWebComponent,
  CloudStagingListWebComponent,
  CloudStagingSideBarWebComponent,
  GroupAttributionIocSidePanelWebComponent,
  ActorCardWebComponent,
  GroupAttributionMitreSidePanelWebComponent,
  GroupAttributionCveSidePanelWebComponent,
  GzIzIntegrationStatusWebComponent,
  DeviceControlExclusionsWebComponent,
  GzDeviceControlExclusionsGridWebComponent,
  GzRelayCommunicationWebComponent,
  GzRelayUpdateWebComponent,
  GzRelayUpdateLocationsTableWebComponent,
  GzRelayUpdateLocationItemFormWebComponent,
  GzRelayCommunicationWhitelistTableWebComponent,
  GzRelayCommunicationWhitelistItemFormWebComponent,
  ComplianceAppWebComponent,
  BreachPathAppWebComponent,
  BreachPathDetailsWebComponent,
  BreachPathGraphIconWebComponent,
  BreachPathGraphNodeTypeWebComponent,
  GzDarkModeToggleWebComponent,
  GzSandboxEndpointSensorWebComponent,
  GzLocalSandboxInstanceWebComponent,
  GzProxyConfigurationWebComponent,
  GzContentPrefilteringWebComponent,
  GzDetonationProfileWebComponent,
  GzRemediationActionWebComponent,
  GzFileSizesWebComponent,
  GzSandboxNetworkSensorWebComponent,
  GzSandboxIcapSensorWebComponent,
  GzSandboxManagerWebComponent,
  GzSelectedListWebComponent,
  GzSelectedListItemWebComponent,
  GzSelectedListItemGeneratorWebComponent,
  NetworkScrollableWrapperWebComponent,
  ComplianceOverviewWebComponent,
  GzApplicationControlGeneralWebComponent,
  GzApplicationControlRulesGridWebComponent,
  ManualAddExceptionContainerWebComponent,
  DiscoveredDevicesAddExceptionContainerWebComponent,
  DiscoveredDevicesGridWebComponent,
  GzCarouselInfoCardWebComponent,
  CarouselInfoOverlayStory,
  GzApplicationControlTargetItemFormWebComponent,
  GzApplicationControlTargetsTableWebComponent,
  GzRepairAgentWebComponent,
  GzIsolateEndpointTaskWebComponent,
  GzRemoveFromIsolationTaskWebComponent,
  GzUninstallAgentWebComponent,
  GzGoldenImageAssignationWebComponent,
  CategoriesSideMenuWebComponent,
  GzSchedulerWebComponent,
  IntegrationsMarketplaceAppContainerWebComponent,
  IntegrationsMarketplaceGridInstalledWebComponent,
  IntegrationsMarketplaceGridAvailableWebComponent,
  SaveIntegrationWebComponent,
  VcenterWebComponent,
  ImportOptionsWebComponent,
  MdrContactDetailsFormWebComponent,
  ContactDetailsSectionWebComponent,
  MdrSecurityTelemetryExclusionsGridWebComponent,
  GzNsxWebComponent,
  EditPolicyAssignmentPanelWebComponent,
  GzFirewallSettingsWebComponent,
  GzFirewallSettingsExclusionsTableWrapperWebComponent,
  GzFirewallSettingsExclusionItemFormWebComponent,
  GzFirewallNetworkWebComponent,
  GzFirewallNetworkItemFormWebComponent,
  GzFirewallNetworkTableWebComponent,
  GzFirewallAdaptersTableWebComponent,
  GzFirewallAdvancedWebComponent,
  GzFirewallAdvancedRulesGridWebComponent,
  GzContentControlTrafficExclusionItemFormWebComponent,
  GzContentControlTrafficExclusionsGridWebComponent,
  GzContentControlTrafficWebComponent,
  GzContentControlDataProtectionWebComponent,
  GzContentControlNetworkMonitorWebComponent,
  GzContentControlWebAccessExceptionsItemFormWebComponent,
  GzContentControlWebAccessExceptionsGridWebComponent,
  GzContentControlDataProtectionRulesGridWebComponent,
  GzContentControlDataProtectionExclusionsGridWebComponent,
  GzContentControlApplicationRulesGridWebComponent,
  GzContentControlWebWebComponent,
  GzContentControlDataProtectionRulesLightGridWebComponent,
  AttackSurfaceReductionPotentialWebComponent,
  PhasrDetectedIncidentsWebComponent,
  GatheringDataInfoWebComponent,
  GzWidgetSectionWithIconsAndPercentageItemWebComponent,
  PhasrCategoriesWidgetTemplateWebComponent,
  PhasrTamperingToolsWebComponent,
  PhasrRemoteAdminToolsWebComponent,
  PhasrMinersWebComponent,
  PhasrHackToolsWebComponent,
  PhasrOffLandBinariesWebComponent,
  PhasrTopRecommendationsWebComponent,
  GzDeleteEntityWebComponent,
  PhasrRecommendationsWebComponent,
  PhasrRecommendationsGridWebComponent,
  PhasrSidePanelComponent,
  PhasrMonitoredRulesWebComponent,
  PhasrMonitoredRulesGridWebComponent,
  PhasrMonitoredRulesDetailsPanelComponent,
  MdrCustomerPanelWebComponent,
  MdrCompaniesGridWebComponent,
  GzMarkdownEditorWebComponent,
  GzMarkdownEditorPromptContentWebComponent,
  GzMarkdownEditorTextareaWebComponent,
  GzAssignPolicyWebComponent,
  ChildGroupsGridWebComponent,
  TargetsGridWebComponent,
  GzRiskScanActionWebComponent,
  GzRestartEndpointWebComponent,
  GzTimeRangeSliderWebComponent,
  GzMoveToActionWebComponent,
  GzAssignSecurityServersWebComponent,
  GzCollapsibleTimelineWebComponent,
  GzCollapsibleTimelineItemWebComponent,
  GzCollapsibleTimelineGroupWebComponent,
  GzCollapsibleTimelineLoadMore,
  GzTimelineWebComponent,
  GzExchangeProtectionGeneralWebComponent,
  GzExchangeProtectionAntiSpoofingGridWebComponent,
  GzExchangeProtectionUserGroupsGridWebComponent,
  GzExchangeAntimalwareWebComponent,
  GzExchangeAntimalwareRulesGridWebComponent,
  GzExchangeUserGroupsGridWebComponent,
  GzExchangeAntimalwareScanTasksGridWebComponent,
  GzExchangeAntimalwareExclusionsGridWebComponent,
  GzExchangeAntimalwareScanTaskExclusionsGridWebComponent,
  GzExchangeAntimalwareScanTaskExclusionItemFormWebComponent,
  GzExchangeContentControlContentFilteringRulesGridWebComponent,
  GzExchangeContentControlAttachmentFilteringRulesGridWebComponent,
  GzExchangeContentControlContentFilteringByGridWebComponent,
  GzExchangeContentControlContentFilteringByItemFormWebComponent,
  GzExchangeContentControlWebComponent,
  GzExchangeProtectionAntiSpoofingContainerWebComponent,
  GzExchangeAntispamWebComponent,
  GzExchangeAntispamSettingsTableWebComponent,
  GzExchangeAntispamSettingsItemFormWebComponent,
  GzExchangeAntispamRulesGridWebComponent,
  GzExchangeAntispamRulesFormWebComponent,
  PhasrListWebComponent,
  PhasrListItemWebComponent,
  GzSuspendProtectionWebComponent,
  GzResumeProtectionComponent,
  PhasrRecommendationSideMenuWebComponent,
  GzPhoneInputWebComponent,
  GzSingleSelectListPhoneCodeWebComponent,
  GzSingleSelectPhoneCodeWebComponent,
  WebAccessControlCustomPagesComponent,
  WebAccessControlCustomPagesFormComponent,
  GzPageNavigationHeaderWebComponent,
  PatchesGridWebComponent,
  GzAnimatedHighlightBoxWebComponent,
  GzAnimatedHighlightBoxManager,
  PhasrApplyActionPanelWebComponent,
  PhasrRestrictedProfilesListWebComponent,
  PhasrRestrictedProfilesViewWebComponent,
  PhasrBehavioralProfilesComponent,
  GzOperatingSystemFilterWebComponent,
  SetVmwareIntegratorWebComponent,
  UnsetVmwareIntegratorWebComponent,
  GzSingleSelectLoadedWebComponent,
  IncidentsActivityPanelWebComponent,
  AlertDetailsWebComponent,
  AlertGroupDetailsSidepanelWebComponent,
  GzAntimalwareAntiTamperingWebComponent,
  GzAntimalwareOnAccessWebComponent,
  GzAntimalwareOnAccessUnixPathsTableWebComponent,
  GzAntimalwareOnAccessUnixPathsItemFormWebComponent,
  GzAntimalwareAntiExploitWebComponent,
  GzAntimalwareDynamicThreatDefenseWebComponent,
  GzAntimalwareAntiExploitApplicationsTableWebComponent,
  GzAntimalwareSecurityServersSvaIpsTableWebComponent,
  GzAntimalwareSecurityServersSvaIpsItemFormWebComponent,
  GzAntimalwareSecurityServersWebComponent,
  GzAntimalwareOnExecuteWebComponent,
  GzAntimalwareOnDemandWebComponent,
  GzAntimalwareOnDemandScanTasksGridWebComponent,
  GzAntimalwareOnDemandExclusionsTableWebComponent,
  GzAntimalwareOnDemandExclusionsItemFormWebComponent,
  GzAntimalwareOnDemandScanTargetTableWebComponent,
  GzAntimalwareOnDemandScanTargetItemFormWebComponent,
  GzAntimalwareOnDemandContextualScanFormWebComponent,
  GzAntimalwareOnDemandDeviceScanFormWebComponent,
  GzAntimalwareOnDemandScanTaskGeneralFormWebComponent,
  GzAntimalwareOnDemandScanTaskOptionsFormWebComponent,
  GzAntimalwareOnDemandScanTaskTargetFormWebComponent,
  GzAntimalwareSettingsWebComponent,
  GzAntimalwareExclusionsWebComponent,
  GzAntimalwareExclusionsGridWebComponent,
  GzAntimalwareExclusionsItemFormWebComponent,
  GzAntimalwareExclusionsListsWebComponent,
  GzAntimalwareVendorsExclusionsListsWebComponent,
  GzGeneralSecurityTelemetryWebComponent,
  GzGeneralCommunicationWebComponent,
  GzEcsAssignmentGridWebComponent,
  GzEcsAssignmentItemFormWebComponent,
  GzGeneralDetailsWebComponent,
  GzGeneralNotificationsWebComponent,
  GzGeneralInheritanceRulesWebComponent,
  GzGeneralInheritanceRulesTableWebComponent,
  GzGeneralInheritanceRulesItemFormWebComponent,
  GzGeneralAdvancedWebComponent,
  GzGeneralUpdateWebComponent,
  GzGeneralUpdateLocationsTableWebComponent,
  GzGeneralUpdateLocationItemFormWebComponent,
  GzSelectMenuWithButtonWebComponent,
  GzHorizontalStackedBarChartWebComponent,
  IzIntegrationWebComponent,
  GzSeverityIconWebComponent,
  GzMultiGaugeWebComponent,
  GzNavigationButtonWebComponent,
  GridViewStatusChipWebComponent,
};

export {
  // Risk Management (ERA/IOR)
  VulnerabilitiesAppWebComponent,
  MisconfigurationsAppWebComponent,
  UserBehaviorRisksAppWebComponent,
  UsersAppWebComponent,
  UserBehaviorRisksSideMenuWebComponent,
  DevicesAppWebComponent,
  MisconfigurationsSideMenuWebComponent,
  VulnerabilitiesSideMenuWebComponent,
  UsersSideMenuWebComponent,
  DevicesSideMenuWebComponent,
  ApplicationCveListWebComponent,
  DeviceDetailsWebComponent,
  DeviceExtraDetailsWebComponent,
  UserDetailsWebComponent,
  UserExtraDetailsWebComponent,
  // Risk Management - ASM Dashboard
  GzRmSeverity,
  GzRmSeverityBar,
  GzRmIconsListWebComponent,
  GzRmIconWebComponent,
  GzRmCompanyStateWidgetWebComponent,
  GzRmScoreOverTimeWidgetWebComponent,
  GzRmResourcesByOsWidgetWebComponent,
  GzRmScannedResourcesWidgetWebComponent,
  GzRmScannedIdentitiesWidgetWebComponent,
  GzRmTopFindingsSeverityWidgetWebComponent,
  GzRmTopVulnerabilitiesSeverityWidgetWebComponent,
  GzRmTopIdentityRisksSeverityWidgetWebComponent,
  GzRmTopFindingsImpactWidgetWebComponent,
  GzRmTopVulnerabilitiesImpactWidgetWebComponent,
  GzRmTopIdentityRisksImpactWidgetWebComponent,
  GzRmVulnerabilitiesBreakdownWidgetWebComponent,
  GzRmTopResourcesRiskWidgetWebComponent,
  GzRmTopIdentitiesRiskWidgetWebComponent,
  GzRmTopVulnerabilitiesIncidentsWidgetWebComponent,
  GzRmTopResourcesIncidentsWidgetWebComponent,
  GzRmCvesSeverityWidgetWebComponent,
  GzRmApplicationsSeverityWidgetWebComponent,
  GzRmOldestVulnerabilitiesWidgetWebComponent,
  GzRmZeroTrustWidgetWebComponent,
};

if (!window.globalThis) {
  //@ts-ignore
  window.globalThis = window;
}

if (!globalThis.nirvana) {
  // @ts-ignore
  globalThis.nirvana = {};
}

if (!globalThis.nirvana.dependencies) {
  globalThis.nirvana.dependencies = {};
}

if (!globalThis.nirvana.constants) {
  globalThis.nirvana.constants = {};
}

globalThis.nirvana.dependencies = {
  rxjs: {
    Observable: Observable,
    operators: {
      catchError: catchError,
    },
  },
  timeUtils: {
    timeRangeEnum: TIME_RANGE,
    timeRangeToReportingInterval: timeRangeToReportingInterval,
    jsTimestampToUnixTimestamp: jsTimestampToUnixTimestamp,
    timeRangeSchemaParse: TimeRangeSchema.parse,
  },
  services: {
    buildFormGroup: FormGroup.build,
    buildTreeElement: GzTreeWebComponent.buildTreeElement,
    buildDialogElement: GzDialogWebComponent.buildDialogElement,
    computeCustomDialog: GzDialogWebComponent.computeCustomDialog,
    buildToastNotification: GzToastNotificationWebComponent.buildToastWrapperElement,
    buildInfoOverlayComponent: GzOverlay.show,
    updateInfoOverlayComponentPosition: GzOverlay.updatePosition,
    policyPanelManager: PolicyPanelManager.getInstance(),
    policyDependenciesContainer: PolicyDependenciesContainer.getInstance(),
    showPopup: NetworkPopUpFactory.getContent,
  },
};

if (!globalThis.nirvana.GuidedToursManager) {
  globalThis.nirvana.GuidedToursManager = GuidedToursManager;
}
export type { ExtJsFilter } from './grid/utils/filters/types';

globalThis.nirvana.constants = {
  PopupTypes: Object.fromEntries(Object.entries(NetworkPopUpType).filter(([key, value]) => typeof value === 'number')),
};
